

// import React,{ useState, useEffect, useRef } from "react";
// import axios from "axios";


// /* ─────────────────────────────────────────────
//    FONT + GLOBAL STYLES
// ───────────────────────────────────────────── */
// const Styles = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,200;0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,300&family=DM+Serif+Display:ital@0;1&display=swap');

//     *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

//     :root {
//       --black:   #080810;
//       --bg:      #0a0a12;
//       --bg2:     #0f0f1a;
//       --border:  rgba(255,255,255,0.06);
//       --border2: rgba(255,255,255,0.12);
//       --text1:   #f4f4f6;
//       --text2:   rgba(244,244,246,0.5);
//       --text3:   rgba(244,244,246,0.28);
//       --purple:  #9b5de5;
//       --purple2: #c77dff;
//       --pink:    #e040fb;
//       --accent:  #b06dff;
//     }

//     html { scroll-behavior: smooth; }

//     body {
//       background: var(--bg);
//       color: var(--text1);
//       font-family: 'DM Sans', -apple-system, sans-serif;
//       -webkit-font-smoothing: antialiased;
//       overflow-x: hidden;
//     }

//     /* ── Scrollbar ── */
//     ::-webkit-scrollbar { width: 4px; }
//     ::-webkit-scrollbar-track { background: var(--bg); }
//     ::-webkit-scrollbar-thumb { background: rgba(155,93,229,0.4); border-radius: 2px; }
//     ::selection { background: rgba(155,93,229,0.35); }

//     /* ── Animations ── */
//     @keyframes fadeUp {
//       from { opacity: 0; transform: translateY(28px); }
//       to   { opacity: 1; transform: translateY(0); }
//     }
//     @keyframes fadeIn {
//       from { opacity: 0; } to { opacity: 1; }
//     }
//     @keyframes marquee {
//       from { transform: translateX(0); }
//       to   { transform: translateX(-50%); }
//     }
//     @keyframes blink {
//       0%, 100% { opacity: 1; }
//       50% { opacity: 0; }
//     }
//     @keyframes float {
//       0%, 100% { transform: translateY(0); }
//       50% { transform: translateY(-10px); }
//     }
//     @keyframes glow-pulse {
//       0%, 100% { opacity: 0.15; transform: scale(1); }
//       50% { opacity: 0.28; transform: scale(1.06); }
//     }

//     /* ── Reveal ── */
//     .reveal {
//       opacity: 0;
//       transform: translateY(24px);
//       transition: opacity 0.8s cubic-bezier(.22,.68,0,1.1), transform 0.8s cubic-bezier(.22,.68,0,1.1);
//     }
//     .reveal.in { opacity: 1; transform: translateY(0); }
//     .reveal.d1 { transition-delay: 0.08s; }
//     .reveal.d2 { transition-delay: 0.16s; }
//     .reveal.d3 { transition-delay: 0.24s; }
//     .reveal.d4 { transition-delay: 0.32s; }
//     .reveal.d5 { transition-delay: 0.40s; }

//     /* ── Shared Layout ── */
//     .wrap   { max-width: 1100px; margin: 0 auto; padding: 0 40px; }
//     .wrap-s { max-width: 840px;  margin: 0 auto; padding: 0 40px; }

//     /* ── Nav ── */
//     .nav {
//       position: fixed; top: 0; left: 0; right: 0; z-index: 200;
//       padding: 28px 0;
//       transition: all 0.4s ease;
//     }
//     .nav.stuck {
//       padding: 18px 0;
//       background: rgba(10,10,18,0.88);
//       backdrop-filter: blur(20px);
//       border-bottom: 1px solid var(--border);
//     }
//     .nav-inner {
//       max-width: 1100px; margin: 0 auto; padding: 0 40px;
//       display: flex; align-items: center; justify-content: space-between;
//     }
//     .logo {
//       font-family: 'DM Serif Display', serif;
//       font-size: 22px; color: var(--text1);
//       cursor: pointer; letter-spacing: -0.01em;
//     }
//     .logo span { color: var(--accent); }
//     .nav-links { display: flex; align-items: center; gap: 36px; }
//     .nav-link {
//       font-size: 13.5px; font-weight: 400; letter-spacing: 0.02em;
//       color: var(--text2); cursor: pointer;
//       transition: color 0.2s; text-transform: uppercase;
//     }
//     .nav-link:hover { color: var(--text1); }
//     .nav-link.active { color: var(--text1); }
//     .nav-cta {
//       font-size: 13px; font-weight: 500; padding: 9px 22px;
//       border: 1px solid var(--border2); border-radius: 100px;
//       color: var(--text1); background: transparent;
//       cursor: pointer; transition: all 0.25s;
//       letter-spacing: 0.01em;
//     }
//     .nav-cta:hover { background: rgba(155,93,229,0.12); border-color: var(--accent); color: var(--accent); }

//     /* ── Hamburger ── */
//     .hamburger {
//       display: none; flex-direction: column; gap: 5px; cursor: pointer;
//       width: 28px; padding: 4px 0;
//     }
//     .hamburger span {
//       display: block; height: 1.5px; background: var(--text1);
//       transition: all 0.3s ease; border-radius: 2px;
//     }
//     .hamburger.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
//     .hamburger.open span:nth-child(2) { opacity: 0; }
//     .hamburger.open span:nth-child(3) { transform: rotate(-45deg) translate(5px, -5px); }

//     .mobile-menu {
//       position: fixed; inset: 0; z-index: 199;
//       background: rgba(8,8,16,0.98); backdrop-filter: blur(24px);
//       display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 44px;
//       animation: fadeIn 0.25s ease;
//     }
//     .mobile-nav-link {
//       font-family: 'DM Serif Display', serif;
//       font-size: 42px; color: var(--text2); cursor: pointer;
//       transition: color 0.2s;
//     }
//     .mobile-nav-link:hover { color: var(--text1); }

//     /* ── Hero ── */
//     .hero {
//       display: flex; align-items: center; justify-content: center;
//       text-align: center; position: relative; overflow: hidden;
//       padding: 80px 40px 80px;
//     }
//     .hero-glow {
//       position: absolute; border-radius: 50%; pointer-events: none; filter: blur(100px);
//       animation: glow-pulse 8s ease-in-out infinite;
//     }
//     .hero-eyebrow {
//       display: inline-flex; align-items: center; gap: 10px;
//       font-size: 12px; font-weight: 500; letter-spacing: 0.15em;
//       text-transform: uppercase; color: var(--text3); margin-bottom: 36px;
//     }
//     .hero-eyebrow::before, .hero-eyebrow::after {
//       content: ''; width: 32px; height: 1px; background: var(--border2);
//     }
//     .hero-title {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(44px, 8vw, 98px);
//       line-height: 1.04; letter-spacing: -0.02em;
//       color: var(--text1); margin-bottom: 28px;
//     }
//     .hero-title .light { color: var(--text2); font-style: italic; }
//     .hero-title .accent { color: var(--accent); }
//     .hero-sub {
//       font-size: clamp(15px, 1.8vw, 18px); font-weight: 300;
//       color: var(--text2); line-height: 1.75;
//       max-width: 500px; margin: 0 auto 52px;
//     }
//     .hero-actions { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
//     .btn-primary {
//       display: inline-flex; align-items: center; gap: 8px;
//       padding: 14px 30px; border-radius: 100px;
//       background: linear-gradient(135deg, #7c3aed, #a855f7);
//       color: white; font-size: 14px; font-weight: 500;
//       border: none; cursor: pointer; transition: all 0.3s;
//       box-shadow: 0 0 28px rgba(124,58,237,0.3);
//     }
//     .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 0 44px rgba(124,58,237,0.5); }
//     .btn-outline {
//       display: inline-flex; align-items: center; gap: 8px;
//       padding: 13px 28px; border-radius: 100px;
//       border: 1px solid var(--border2); background: transparent;
//       color: var(--text1); font-size: 14px; font-weight: 400;
//       cursor: pointer; transition: all 0.3s;
//     }
//     .btn-outline:hover { border-color: rgba(155,93,229,0.5); background: rgba(155,93,229,0.06); }
//     .scroll-hint {
//       position: absolute; bottom: 0px; left: 50%; transform: translateX(-50%);
//       display: flex; flex-direction: column; align-items: center; gap: 10px;
//       color: var(--text3); font-size: 11px; letter-spacing: 0.15em; text-transform: uppercase;
//       animation: float 3s ease-in-out infinite;
//     }
//     .scroll-arrow {
//       width: 1px; height: 36px; background: linear-gradient(to bottom, var(--text3), transparent);
//     }

//     /* ── Section separator ── */
//     .sep { height: 1px; background: var(--border); margin: 0; }

//     /* ── Clients / Marquee ── */
//     .clients-section { padding: 80px 0; }
//     .clients-label {
//       font-size: 13px; font-weight: 300; color: var(--text3);
//       letter-spacing: 0.06em; margin-bottom: 48px; padding: 0 40px;
//     }
//     .clients-label strong { color: var(--text2); font-weight: 500; }
//     .marquee-wrap { overflow: hidden; }
//     .marquee-track {
//       display: flex; width: max-content;
//       animation: marquee 32s linear infinite;
//     }
//     .marquee-track:hover { animation-play-state: paused; }
//     .client-item {
//       display: flex; align-items: center; gap: 10px;
//       padding: 0 44px; opacity: 0.3;
//       font-size: 15px; font-weight: 500; letter-spacing: 0.04em;
//       color: var(--text1); white-space: nowrap;
//       transition: opacity 0.3s; cursor: default;
//     }
//     .client-item:hover { opacity: 0.7; }
//     .client-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--accent); }

//     /* ── Work Section ── */
//     .work-section { padding: 100px 0; }
//     .section-label {
//       font-size: 12px; font-weight: 500; letter-spacing: 0.14em;
//       text-transform: uppercase; color: var(--text3); margin-bottom: 16px;
//     }
//     .section-heading {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(36px, 5vw, 60px); line-height: 1.08;
//       letter-spacing: -0.02em; color: var(--text1);
//     }
//     .section-heading .dim { color: var(--text2); font-style: italic; }

//     /* Work items — alternating layout */
//     .work-list { display: flex; flex-direction: column; gap: 0; }
//     .work-item {
//       display: grid; grid-template-columns: 1fr 1fr;
//       gap: 0; align-items: center;
//       padding: 80px 0; border-bottom: 1px solid var(--border);
//       cursor: pointer;
//     }
//     .work-item:last-child { border-bottom: none; }
//     .work-item.flip { direction: rtl; }
//     .work-item.flip > * { direction: ltr; }
//     .work-img {
//       aspect-ratio: 16/10; border-radius: 16px; overflow: hidden;
//       position: relative;
//       background: var(--bg2);
//       border: 1px solid var(--border);
//     }
//     .work-img-inner {
//       width: 100%; height: 100%;
//       transition: transform 0.6s cubic-bezier(.22,.68,0,1.1);
//       display: flex; align-items: center; justify-content: center;
//     }
//     .work-item:hover .work-img-inner { transform: scale(1.04); }
//     .work-img-placeholder {
//       width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
//       font-size: 13px; color: var(--text3); letter-spacing: 0.08em;
//     }
//     .work-info { padding: 0 60px; }
//     .work-item.flip .work-info { padding: 0 60px 0 0; }
//     .work-category {
//       font-size: 11px; font-weight: 500; letter-spacing: 0.14em;
//       text-transform: uppercase; color: var(--accent); margin-bottom: 16px;
//     }
//     .work-title {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(28px, 3.5vw, 44px); line-height: 1.1;
//       letter-spacing: -0.02em; color: var(--text1); margin-bottom: 18px;
//     }
//     .work-desc {
//       font-size: 15px; font-weight: 300; color: var(--text2);
//       line-height: 1.78; margin-bottom: 28px; max-width: 380px;
//     }
//     .work-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 32px; }
//     .tag {
//       font-size: 11px; font-weight: 500; padding: 5px 14px;
//       border-radius: 100px; border: 1px solid var(--border2);
//       color: var(--text3); letter-spacing: 0.04em;
//     }
//     .work-link {
//       display: inline-flex; align-items: center; gap: 8px;
//       font-size: 13px; font-weight: 500; color: var(--text1);
//       letter-spacing: 0.04em; text-transform: uppercase;
//       border-bottom: 1px solid var(--border2); padding-bottom: 2px;
//       transition: all 0.25s; cursor: pointer;
//     }
//     .work-link:hover { color: var(--accent); border-color: var(--accent); gap: 14px; }
//     .work-num {
//       position: absolute; top: 20px; left: 24px;
//       font-size: 11px; color: var(--text3); letter-spacing: 0.08em;
//     }

//     /* ── About ── */
//     .about-section { padding: 100px 0; }
//     .about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
//     .about-label { font-size: 11px; font-weight: 500; letter-spacing: 0.14em; text-transform: uppercase; color: var(--text3); margin-bottom: 24px; }
//     .about-text {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(24px, 3vw, 38px); line-height: 1.35;
//       letter-spacing: -0.01em; color: var(--text1); margin-bottom: 28px;
//     }
//     .about-text .dim { color: var(--text2); }
//     .about-text em { color: var(--accent); font-style: italic; }
//     .about-body { font-size: 15px; font-weight: 300; color: var(--text2); line-height: 1.82; margin-bottom: 36px; }
//     .about-stats { display: flex; gap: 36px; }
//     .stat-num {
//       font-family: 'DM Serif Display', serif;
//       font-size: 42px; letter-spacing: -0.02em; color: var(--text1); line-height: 1;
//     }
//     .stat-label { font-size: 12px; color: var(--text3); margin-top: 4px; letter-spacing: 0.04em; }
//     .about-visual { display: flex; flex-direction: column; gap: 16px; }
//     .tech-section-inner {
//       background: var(--bg2); border: 1px solid var(--border);
//       border-radius: 16px; padding: 28px;
//     }
//     .tech-section-title { font-size: 11px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--text3); margin-bottom: 18px; }
//     .tech-grid { display: flex; flex-wrap: wrap; gap: 8px; }
//     .tech-pill {
//       font-size: 12px; font-weight: 400; padding: 6px 14px;
//       border-radius: 100px; border: 1px solid var(--border);
//       color: var(--text2); background: transparent;
//       transition: all 0.25s; cursor: default;
//     }
//     .tech-pill:hover { border-color: rgba(155,93,229,0.4); color: var(--text1); background: rgba(155,93,229,0.06); }

//     /* ── Services ── */
//     .services-section { padding: 100px 0; }
//     .services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px; background: var(--border); border: 1px solid var(--border); border-radius: 16px; overflow: hidden; margin-top: 64px; }
//     .service-card { padding: 36px 32px; background: var(--bg); transition: background 0.3s; }
//     .service-card:hover { background: var(--bg2); }
//     .service-num { font-size: 11px; color: var(--text3); letter-spacing: 0.08em; margin-bottom: 20px; }
//     .service-icon { font-size: 22px; margin-bottom: 16px; }
//     .service-title { font-size: 16px; font-weight: 500; color: var(--text1); margin-bottom: 10px; line-height: 1.3; }
//     .service-desc { font-size: 13px; font-weight: 300; color: var(--text3); line-height: 1.7; }

//     /* ── Contact ── */
//     .contact-section {
//       padding: 160px 0 100px; text-align: center; position: relative; overflow: hidden;
//     }
//     .contact-glow {
//       position: absolute; width: 600px; height: 600px; border-radius: 50%;
//       background: radial-gradient(ellipse, rgba(124,58,237,0.12), transparent 70%);
//       top: 50%; left: 50%; transform: translate(-50%, -50%); pointer-events: none;
//     }
//     .contact-title {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(52px, 10vw, 120px); line-height: 1;
//       letter-spacing: -0.03em; position: relative; z-index: 1;
//       margin-bottom: 24px;
//     }
//     .contact-title .dim { color: var(--text2); }
//     .contact-title .accent { color: var(--accent); }
//     .contact-sub { font-size: 16px; font-weight: 300; color: var(--text3); margin-bottom: 52px; position: relative; z-index: 1; }
//     .contact-icons { display: flex; gap: 20px; justify-content: center; margin-bottom: 60px; position: relative; z-index: 1; flex-wrap: wrap; }
//     .contact-icon-btn {
//       width: 52px; height: 52px; border-radius: 50%;
//       border: 1px solid var(--border2); background: transparent;
//       display: flex; align-items: center; justify-content: center;
//       cursor: pointer; transition: all 0.3s; font-size: 18px; color: var(--text2);
//       text-decoration: none;
//     }
//     .contact-icon-btn:hover { border-color: var(--accent); background: rgba(155,93,229,0.1); color: var(--text1); transform: translateY(-3px); }
//     .contact-email {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(16px, 2.5vw, 22px); color: var(--text2);
//       position: relative; z-index: 1; letter-spacing: -0.01em;
//     }
//     .contact-email a { color: inherit; text-decoration: none; border-bottom: 1px solid var(--border2); padding-bottom: 2px; transition: all 0.25s; }
//     .contact-email a:hover { color: var(--text1); border-color: var(--accent); }

//     /* ── Contact Form ── */
//     .contact-form { max-width: 480px; margin: 52px auto 0; text-align: left; position: relative; z-index: 1; }
//     .form-group { margin-bottom: 20px; }
//     .form-label { font-size: 11px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--text3); display: block; margin-bottom: 10px; }
//     .form-input {
//       width: 100%; padding: 14px 18px; border-radius: 10px;
//       border: 1px solid var(--border); background: rgba(255,255,255,0.03);
//       color: var(--text1); font-size: 14px; font-family: 'DM Sans', sans-serif;
//       outline: none; transition: border-color 0.25s;
//     }
//     .form-input:focus { border-color: rgba(155,93,229,0.5); background: rgba(155,93,229,0.04); }
//     .form-input::placeholder { color: var(--text3); }
//     textarea.form-input { resize: vertical; min-height: 120px; line-height: 1.6; }
//     .form-submit { width: 100%; margin-top: 8px; padding: 15px; border-radius: 10px; }

//     /* ── Footer ── */
//     .footer { padding: 32px 0; border-top: 1px solid var(--border); }
//     .footer-inner {
//       max-width: 1100px; margin: 0 auto; padding: 0 40px;
//       display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;
//     }
//     .footer-copy { font-size: 12px; color: var(--text3); letter-spacing: 0.04em; }
//     .footer-links { display: flex; gap: 24px; }
//     .footer-link { font-size: 12px; color: var(--text3); cursor: pointer; transition: color 0.2s; letter-spacing: 0.04em; }
//     .footer-link:hover { color: var(--text2); }

//     /* ── Page transitions ── */
//     .page { animation: fadeIn 0.5s ease; }

//     /* ── Case Studies Page ── */
//     .cs-page-hero { padding: 160px 0 80px; }
//     .cs-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(340px, 1fr)); gap: 24px; margin-top: 64px; }
//     .cs-card {
//       background: var(--bg2); border: 1px solid var(--border);
//       border-radius: 20px; overflow: hidden; cursor: pointer;
//       transition: border-color 0.3s, transform 0.4s cubic-bezier(.22,.68,0,1.1);
//     }
//     .cs-card:hover { border-color: rgba(155,93,229,0.3); transform: translateY(-6px); }
//     .cs-card-banner { height: 200px; position: relative; overflow: hidden; }
//     .cs-card-banner-inner { width: 100%; height: 100%; transition: transform 0.6s cubic-bezier(.22,.68,0,1.1); }
//     .cs-card:hover .cs-card-banner-inner { transform: scale(1.05); }
//     .cs-card-body { padding: 28px; }
//     .cs-card-cat { font-size: 11px; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: var(--accent); margin-bottom: 10px; }
//     .cs-card-title { font-family: 'DM Serif Display', serif; font-size: 24px; letter-spacing: -0.01em; color: var(--text1); margin-bottom: 12px; line-height: 1.2; }
//     .cs-card-desc { font-size: 14px; font-weight: 300; color: var(--text2); line-height: 1.72; margin-bottom: 20px; }

//     /* ── Detail Page ── */
//     .detail-hero { padding: 140px 0 80px; border-bottom: 1px solid var(--border); }
//     .detail-back {
//       display: inline-flex; align-items: center; gap: 8px;
//       font-size: 12px; letter-spacing: 0.1em; text-transform: uppercase;
//       color: var(--text3); cursor: pointer; margin-bottom: 48px;
//       transition: color 0.2s; border: none; background: none;
//     }
//     .detail-back:hover { color: var(--text2); }
//     .detail-cat { font-size: 12px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--accent); margin-bottom: 20px; }
//     .detail-title {
//       font-family: 'DM Serif Display', serif;
//       font-size: clamp(40px, 7vw, 80px); line-height: 1.06;
//       letter-spacing: -0.03em; margin-bottom: 24px;
//     }
//     .detail-subtitle { font-size: 18px; font-weight: 300; color: var(--text2); line-height: 1.7; max-width: 560px; margin-bottom: 40px; }
//     .detail-meta { display: flex; gap: 48px; flex-wrap: wrap; }
//     .detail-meta-item label { font-size: 10px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--text3); display: block; margin-bottom: 6px; }
//     .detail-meta-item span { font-size: 14px; font-weight: 400; color: var(--text2); }
//     .detail-body { padding: 80px 0; }
//     .detail-section { margin-bottom: 72px; }
//     .detail-section-label { font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--accent); margin-bottom: 20px; }
//     .detail-section-title { font-family: 'DM Serif Display', serif; font-size: 32px; letter-spacing: -0.02em; color: var(--text1); margin-bottom: 20px; }
//     .detail-text { font-size: 15px; font-weight: 300; color: var(--text2); line-height: 1.85; }
//     .detail-features { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 28px; }
//     .detail-feature {
//       padding: 24px; border-radius: 12px;
//       border: 1px solid var(--border); background: var(--bg2);
//     }
//     .detail-feature-title { font-size: 14px; font-weight: 500; color: var(--text1); margin-bottom: 8px; }
//     .detail-feature-desc { font-size: 13px; font-weight: 300; color: var(--text3); line-height: 1.65; }
//     .detail-results { display: flex; gap: 20px; flex-wrap: wrap; margin-top: 28px; }
//     .result-pill {
//       padding: 16px 24px; border-radius: 12px;
//       border: 1px solid rgba(155,93,229,0.2); background: rgba(155,93,229,0.06);
//     }
//     .result-num { font-family: 'DM Serif Display', serif; font-size: 32px; color: var(--accent); line-height: 1; }
//     .result-text { font-size: 12px; color: var(--text3); margin-top: 6px; letter-spacing: 0.04em; }

//     /* ── Responsive ── */
//     @media (max-width: 900px) {
//       .nav-links { display: none; }
//       .hamburger { display: flex; }
//       .wrap { padding: 0 24px; }
//       .wrap-s { padding: 0 24px; }
//       .work-item { grid-template-columns: 1fr; padding: 56px 0; gap: 36px; }
//       .work-item.flip { direction: ltr; }
//       .work-info { padding: 0 !important; }
//       .about-grid { grid-template-columns: 1fr; gap: 48px; }
//       .services-grid { grid-template-columns: 1fr 1fr; }
//       .detail-features { grid-template-columns: 1fr; }
//       .cs-grid { grid-template-columns: 1fr; }
//     }
//     @media (max-width: 600px) {
//       .hero-title { font-size: clamp(38px, 11vw, 60px); }
//       .services-grid { grid-template-columns: 1fr; }
//       .about-stats { gap: 24px; }
//       .nav-cta { display: none; }
//       .detail-meta { gap: 24px; }
//       .detail-results { flex-direction: column; }
//     }
//   `}</style>
// );

// /* ─────────────────────────────────────────────
//    DATA
// ───────────────────────────────────────────── */
// const PROJECTS = [
//   {
//     id: "nupal-cdc",
//     num: "01",
//     category: "Healthcare SaaS",
//     title: "Nupal CDC",
//     subtitle: "Therapy Clinic Platform",
//     desc: "A comprehensive therapy clinic management platform featuring appointment scheduling, therapist availability management, patient records, payment processing, and automated workflow systems.",
//     tags: ["Next.js", "Node.js", "MongoDB", "Stripe"],
//     url: "https://booking.nupalcdc.com/",
//     gradient: "linear-gradient(135deg, #0d1b4b 0%, #1a3a8f 50%, #4f46e5 100%)",
//     accentColor: "#6366f1",
//     problem: "The clinic managed appointments via phone calls and paper diaries — leading to double bookings, missed reminders, and no consolidated patient history.",
//     solution: "Delivered a fully integrated clinic platform with online booking, therapist calendar management, patient EHR, payments, and automated reminder workflows.",
//     features: [
//       { title: "Online Booking Portal", desc: "Patients book appointments 24/7 with real-time availability." },
//       { title: "Therapist Calendars", desc: "Each therapist manages their own schedule and availability." },
//       { title: "Patient History", desc: "Session notes, treatment history, and progress tracking." },
//       { title: "Payment Integration", desc: "Stripe-powered billing with invoices and receipts." },
//       { title: "Automated Reminders", desc: "SMS and email reminders reduce no-shows significantly." },
//       { title: "Staff Dashboard", desc: "Role-based access for admins, therapists, and reception." },
//     ],
//     results: [
//       { num: "300+", label: "Monthly bookings" },
//       { num: "0", label: "Double bookings" },
//       { num: "4×", label: "Faster admin workflow" },
//     ],
//     challenges: "Building real-time calendar conflict detection across multiple therapist types while maintaining HIPAA-aligned data practices was the core engineering challenge.",
//   },
//   {
//     id: "dairy-management",
//     num: "02",
//     category: "Business Automation",
//     title: "Dholpur Fresh",
//     subtitle: "Dairy Management System",
//     desc: "A multi-role vendor and reporting management system with automation workflows, Excel processing, asset tracking, and API integration — eliminating 100% of manual spreadsheet operations.",
//     tags: ["React", "Node.js", "PostgreSQL", "Redis"],
//     url: "https://dholpurfresh.site/",
//     gradient: "linear-gradient(135deg, #1a0533 0%, #3b0764 50%, #7c3aed 100%)",
//     accentColor: "#a855f7",
//     problem: "40+ vendors managed via fragmented WhatsApp messages and Excel files, with no audit trail, frequent errors, and days-long report generation cycles.",
//     solution: "A unified multi-role SaaS platform with vendor portals, automated pipelines, real-time dashboards, and zero manual Excel dependency.",
//     features: [
//       { title: "Multi-Role Access", desc: "Admin, Vendor, and Staff portals with distinct permissions." },
//       { title: "Excel Automation", desc: "Automated import/export of operational data." },
//       { title: "Live Dashboards", desc: "Real-time sales, payments, and vendor metrics." },
//       { title: "Asset Tracking", desc: "End-to-end lifecycle management of physical assets." },
//       { title: "Invoice Generation", desc: "Automated PDF invoices sent on trigger events." },
//       { title: "API Integrations", desc: "Third-party connections for payments and logistics." },
//     ],
//     results: [
//       { num: "60%", label: "Faster reporting" },
//       { num: "40+", label: "Vendors managed" },
//       { num: "100%", label: "Manual work eliminated" },
//     ],
//     challenges: "Migrating 3 years of Excel data without loss while building a real-time vendor sync system across unstable mobile connections.",
//   },
//   {
//     id: "auto-daddy",
//     num: "03",
//     category: "Marketplace Platform",
//     title: "Auto Daddy",
//     subtitle: "Automotive Services Platform",
//     desc: "A dual-sided marketplace connecting vehicle owners with service providers — featuring real-time booking, vendor dashboards, job tracking, and a full admin console.",
//     tags: ["React Native", "Node.js", "MongoDB", "AWS"],
//     url: "#",
//     gradient: "linear-gradient(135deg, #1a0a00 0%, #7c2d12 50%, #ea580c 100%)",
//     accentColor: "#f97316",
//     problem: "Auto service providers had no digital presence. Customers had no reliable way to discover, compare, or book automotive services in their city.",
//     solution: "Full marketplace platform — customer app, vendor dashboard, and admin console — enabling seamless discovery, booking, and fulfillment.",
//     features: [
//       { title: "Customer App", desc: "iOS and Android app for discovering and booking services." },
//       { title: "Vendor Dashboard", desc: "Service providers manage listings, bookings, and earnings." },
//       { title: "Live Job Tracking", desc: "Real-time status updates throughout the service lifecycle." },
//       { title: "In-App Chat", desc: "Direct communication between customers and vendors." },
//       { title: "Reviews & Ratings", desc: "Trust-building review system for service quality." },
//       { title: "Admin Console", desc: "Full operational oversight and dispute management." },
//     ],
//     results: [
//       { num: "3", label: "Cities launched" },
//       { num: "120+", label: "Service providers" },
//       { num: "2-sided", label: "Marketplace live" },
//     ],
//     challenges: "Real-time location-based vendor discovery with a complex booking state machine that handles cancellations, reschedules, and partial completions.",
//   },
// ];

// const OTHER_PROJECTS = [
//   { name: "B.S. Advertising Co.", category: "Web App", desc: "CRM & property listing platform", url: "https://hariomrealest.com/" },
//   { name: "Hariom Properties", category: "Web App", desc: "Real estate management system", url: "https://hariomprop.com/" },
//   { name: "Sudhoshan Skills", category: "Web + CMS", desc: "Skill training platform with CMS", url: "https://sudhosanskillsolutions.in/" },
//   { name: "RJ Solar Panels", category: "Website", desc: "Solar energy company site", url: "#" },
//   { name: "Sharda Clinic", category: "Website", desc: "Medical clinic & appointments", url: "#" },
//   { name: "Vanrang Foundation", category: "Website", desc: "NGO & charity platform", url: "#" },
// ];

// const CLIENTS = [
//   "Nupal CDC", "Dholpur Fresh", "Auto Daddy", "Hariom Properties",
//   "B.S. Advertising", "RJ Solar", "Sudhoshan Skills", "Sharda Clinic",
//   "Vanrang Foundation", "GoWappily", "Smile Dental", "Astro Academy",
// ];

// const SERVICES = [
//   { num: "01", icon: "⚙️", title: "Custom Business Software", desc: "Bespoke systems that fit your exact workflow — not off-the-shelf compromises." },
//   { num: "02", icon: "📊", title: "Dashboards & Admin Systems", desc: "Real-time, data-rich dashboards and internal tools your team actually uses." },
//   { num: "03", icon: "🌐", title: "Full Stack Web Development", desc: "End-to-end web apps from architecture to production deployment." },
//   { num: "04", icon: "🔌", title: "API & Backend Development", desc: "Scalable REST APIs, microservices, and backend architectures." },
//   { num: "05", icon: "⚡", title: "Automation Systems", desc: "Eliminate manual work with intelligent, reliable automation pipelines." },
//   { num: "06", icon: "🔗", title: "Workflow Solutions", desc: "Map complex business processes to clean, efficient digital systems." },
// ];

// const TECH = {
//   Frontend: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion", "GSAP", "Three.js"],
//   Backend: ["Node.js", "Express", "MongoDB", "PostgreSQL", "MySQL", "RESTful APIs"],
//   Tools: ["Git", "GitHub", "Docker", "AWS EC2", "Render", "Postman", "VS Code"],
// };

// /* ─────────────────────────────────────────────
//    HOOKS
// ───────────────────────────────────────────── */
// function useScrollReveal() {
//   useEffect(() => {
//     const els = document.querySelectorAll(".reveal");
//     const obs = new IntersectionObserver(
//       (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("in"); }),
//       { threshold: 0.08 }
//     );
//     els.forEach((el) => obs.observe(el));
//     return () => obs.disconnect();
//   });
// }

// function useScrolled() {
//   const [scrolled, setScrolled] = useState(false);
//   useEffect(() => {
//     const h = () => setScrolled(window.scrollY > 40);
//     window.addEventListener("scroll", h);
//     return () => window.removeEventListener("scroll", h);
//   }, []);
//   return scrolled;
// }

// /* ─────────────────────────────────────────────
//    NAV
// ───────────────────────────────────────────── */
// function Nav({ page, setPage }) {
//   const scrolled = useScrolled();
//   const [open, setOpen] = useState(false);
//   const go = (p) => { setPage(p); window.scrollTo(0, 0); setOpen(false); };
//   const links = [
//     { label: "Work", page: "home", hash: "#work" },
//     { label: "Case Studies", page: "case-studies" },
//     { label: "About", page: "home", hash: "#about" },
//     { label: "Contact", page: "contact" },
//   ];

//   return (
//     <>
//       <nav className={`nav ${scrolled ? "stuck" : ""}`}>
//         <div className="nav-inner">
//           <div className="logo" onClick={() => go("home")}>
//             dev<span>yugal</span>
//           </div>
//           <div className="nav-links">
//             {links.map((l) => (
//               <span
//                 key={l.label}
//                 className={`nav-link ${page === l.page && !l.hash ? "active" : ""}`}
//                 onClick={() => { go(l.page); if (l.hash) setTimeout(() => document.querySelector(l.hash)?.scrollIntoView({ behavior: "smooth" }), 100); }}
//               >
//                 {l.label}
//               </span>
//             ))}
//           </div>
//           <button className="nav-cta" onClick={() => go("contact")}>Let's Talk</button>
//           <div className={`hamburger ${open ? "open" : ""}`} onClick={() => setOpen(!open)}>
//             <span /><span /><span />
//           </div>
//         </div>
//       </nav>

//       {open && (
//         <div className="mobile-menu">
//           <button onClick={() => setOpen(false)} style={{ position: "absolute", top: 28, right: 28, background: "none", border: "none", color: "var(--text2)", fontSize: 24, cursor: "pointer" }}>✕</button>
//           {["home", "case-studies", "contact"].map((p) => (
//             <span key={p} className="mobile-nav-link" onClick={() => go(p)}>
//               {p === "home" ? "Home" : p === "case-studies" ? "Work" : "Contact"}
//             </span>
//           ))}
//         </div>
//       )}
//     </>
//   );
// }

// /* ─────────────────────────────────────────────
//    HOME PAGE
// ───────────────────────────────────────────── */
// function HeroSection({ setPage }) {
//   return (
//     <section className="hero">
//       <div className="hero-glow" style={{ width: 700, height: 700, background: "radial-gradient(ellipse, rgba(124,58,237,0.18), rgba(168,85,247,0.06) 50%, transparent 70%)", top: "50%", left: "50%", transform: "translate(-50%,-50%)" }} />

//       <div style={{ position: "relative", zIndex: 1, maxWidth: 860, margin: "0 auto" }}>
//         <div className="hero-eyebrow reveal">
//           Full Stack Developer 
//           {/* · Uttarakhand, India */}
//         </div>

//         <h1 className="hero-title reveal d1">
//           <span className="light">I build systems</span><br />
//           that power<br />
//           <span className="accent">real businesses.</span>
//         </h1>

//         <p className="hero-sub reveal d2">
//           Scalable web applications, internal tools, and automation platforms
//           that help organizations streamline workflows and operate smarter.
//         </p>

//         <div className="hero-actions reveal d3">
//           <button className="btn-primary" onClick={() => { setPage("case-studies"); window.scrollTo(0, 0); }}>
//             View Case Studies
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//           </button>
//           <button className="btn-outline" onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>
//             Contact Me
//           </button>
//         </div>
//       </div>

//       <div className="scroll-hint">
//         <span>Scroll</span>
//         <div className="scroll-arrow" />
//       </div>
//     </section>
//   );
// }

// function ClientsSection() {
//   const items = [...CLIENTS, ...CLIENTS];
//   return (
//     <section className="clients-section">
//       <div className="wrap">
//         <p className="clients-label reveal">
//           Some of the <strong>businesses I've built for</strong>
//         </p>
//       </div>
//       <div className="marquee-wrap">
//         <div className="marquee-track">
//           {items.map((name, i) => (
//             <div key={i} className="client-item">
//               <div className="client-dot" />
//               {name}
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function WorkSection({ setPage, setProject }) {
//   return (
//     <section className="work-section" id="work">
//       <div className="wrap">
//         <p className="section-label reveal">Selected Work</p>
//         <h2 className="section-heading reveal d1">
//           <span className="dim">Systems I've</span><br />
//           engineered.
//         </h2>

//         <div className="work-list" style={{ marginTop: 72 }}>
//           {PROJECTS.map((p, i) => (
//             <div
//               key={p.id}
//               className={`work-item reveal d${(i % 3) + 1} ${i % 2 === 1 ? "flip" : ""}`}
//               onClick={() => { setProject(p.id); setPage("detail"); window.scrollTo(0, 0); }}
//             >
//               <div className="work-img">
//                 <div className="work-img-inner" style={{ background: p.gradient }}>
//                   <div style={{ textAlign: "center", padding: 32 }}>
//                     <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 72, color: "rgba(255,255,255,0.08)", lineHeight: 1 }}>{p.num}</div>
//                     <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", letterSpacing: "0.1em", textTransform: "uppercase", marginTop: 8 }}>{p.subtitle}</div>
//                   </div>
//                 </div>
//                 <span className="work-num">{p.num}</span>
//               </div>
//               <div className="work-info">
//                 <p className="work-category">{p.category}</p>
//                 <h3 className="work-title">{p.title}</h3>
//                 <p className="work-desc">{p.desc}</p>
//                 <div className="work-tags">
//                   {p.tags.map((t) => <span key={t} className="tag">{t}</span>)}
//                 </div>
//                 <span className="work-link">
//                   View Case Study
//                   <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                 </span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function OtherProjects() {
//   return (
//     <section style={{ padding: "80px 0", borderTop: "1px solid var(--border)" }}>
//       <div className="wrap">
//         <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 48, flexWrap: "wrap", gap: 16 }}>
//           <div>
//             <p className="section-label reveal">More Projects</p>
//             <h2 className="section-heading reveal d1" style={{ fontSize: "clamp(28px, 4vw, 44px)" }}>
//               <span className="dim">60+ projects</span><br />
//               delivered.
//             </h2>
//           </div>
//         </div>

//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "1px", background: "var(--border)", border: "1px solid var(--border)", borderRadius: 16, overflow: "hidden" }}>
//           {OTHER_PROJECTS.map((p, i) => (
//             <div
//               key={p.name}
//               className="reveal"
//               style={{
//                 padding: "28px 30px", background: "var(--bg)",
//                 transition: "background 0.3s", cursor: "pointer",
//               }}
//               onMouseEnter={e => e.currentTarget.style.background = "var(--bg2)"}
//               onMouseLeave={e => e.currentTarget.style.background = "var(--bg)"}
//               onClick={() => p.url !== "#" && window.open(p.url, "_blank")}
//             >
//               <p style={{ fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--accent)", marginBottom: 10 }}>{p.category}</p>
//               <h3 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: "var(--text1)", marginBottom: 8, lineHeight: 1.2 }}>{p.name}</h3>
//               <p style={{ fontSize: 13, color: "var(--text3)", fontWeight: 300 }}>{p.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function AboutSection() {
//   return (
//     <section className="about-section" id="about">
//       <div className="wrap">
//         <div className="about-grid">
//           <div>
//             <p className="about-label reveal">A bit about me</p>
//             <h2 className="about-text reveal d1">
//               <span className="dim">Hey, I'm</span> Yugal Raj —<br />
//               a developer from<br />
//               <em>Uttarakhand, India.</em>
//             </h2>
//             <p className="about-body reveal d2">
//               I don't just build websites — I engineer systems. From multi-role business platforms
//               to automation pipelines that replace entire manual workflows, I focus on software
//               that has real operational impact.
//             </p>
//             <p className="about-body reveal d3" style={{ marginTop: -12 }}>
//               I specialize in full-stack development with a focus on business automation,
//               internal tools, and data-rich dashboards. I also work with GSAP, Framer Motion,
//               and Three.js for expressive, high-quality interfaces.
//             </p>
//             <div className="about-stats reveal d4">
//               {[
//                 { num: "4+", label: "Years building" },
//                 { num: "40+", label: "Businesses served" },
//                 { num: "60+", label: "Projects shipped" },
//               ].map((s) => (
//                 <div key={s.label}>
//                   <div className="stat-num">{s.num}</div>
//                   <div className="stat-label">{s.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="about-visual reveal d2">
//             {Object.entries(TECH).map(([group, techs]) => (
//               <div key={group} className="tech-section-inner">
//                 <p className="tech-section-title">{group}</p>
//                 <div className="tech-grid">
//                   {techs.map((t) => <span key={t} className="tech-pill">{t}</span>)}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function ServicesSection() {
//   return (
//     <section className="services-section">
//       <div className="wrap">
//         <p className="section-label reveal">What I Do</p>
//         <h2 className="section-heading reveal d1">
//           <span className="dim">Services I</span><br />
//           offer.
//         </h2>
//         <div className="services-grid">
//           {SERVICES.map((s) => (
//             <div key={s.num} className="service-card reveal">
//               <p className="service-num">{s.num}</p>
//               <div className="service-icon">{s.icon}</div>
//               <h3 className="service-title">{s.title}</h3>
//               <p className="service-desc">{s.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// function ContactTeaser({ setPage }) {
//   return (
//     <section style={{ padding: "80px 0", borderTop: "1px solid var(--border)" }}>
//       <div className="wrap-s" style={{ textAlign: "center" }}>
//         <p className="section-label reveal" style={{ justifyContent: "center", display: "block" }}>Let's Build Together</p>
//         <h2 className="section-heading reveal d1" style={{ fontSize: "clamp(36px, 6vw, 72px)", textAlign: "center", marginBottom: 24 }}>
//           <span className="dim">Have a project</span><br />
//           in mind?
//         </h2>
//         <p className="reveal d2" style={{ fontSize: 16, fontWeight: 300, color: "var(--text2)", lineHeight: 1.75, marginBottom: 40, maxWidth: 420, margin: "0 auto 40px" }}>
//           Whether it's a system rebuild, a new automation platform, or a product from scratch — let's talk.
//         </p>
//         <div className="reveal d3" style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
//           <button className="btn-primary" onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>
//             Start a Project
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//           </button>
//           <a href="https://wa.me/+919837114001" target="_blank" rel="noreferrer" className="btn-outline" style={{ textDecoration: "none" }}>
//             WhatsApp Me
//           </a>
//         </div>
//       </div>
//     </section>
//   );
// }

// /* ─────────────────────────────────────────────
//    FOOTER
// ───────────────────────────────────────────── */
// function Footer({ setPage }) {
//   return (
//     <footer className="footer">
//       <div className="footer-inner">
//         <span className="footer-copy">© 2025 Yugal Raj Vimal · devyugal.in</span>
//         <div className="footer-links">
//           {[["Home", "home"], ["Case Studies", "case-studies"], ["Contact", "contact"]].map(([l, p]) => (
//             <span key={p} className="footer-link" onClick={() => { setPage(p); window.scrollTo(0, 0); }}>{l}</span>
//           ))}
//         </div>
//         <span className="footer-copy">yugal@devyugal.in</span>
//       </div>
//     </footer>
//   );
// }

// /* ─────────────────────────────────────────────
//    HOME PAGE
// ───────────────────────────────────────────── */
// function HomePage({ setPage, setProject }) {
//   useScrollReveal();
//   return (
//     <div className="page">
//       <HeroSection setPage={setPage} />
//       <div className="sep" />
//       <ClientsSection />
//       <div className="sep" />
//       <WorkSection setPage={setPage} setProject={setProject} />
//       <OtherProjects />
//       <div className="sep" />
//       <ServicesSection />
//       <div className="sep" />
//       <AboutSection />
//       <ContactTeaser setPage={setPage} />
//       <Footer setPage={setPage} />
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    CASE STUDIES PAGE
// ───────────────────────────────────────────── */
// function CaseStudiesPage({ setPage, setProject }) {
//   useScrollReveal();
//   return (
//     <div className="page">
//       <section className="cs-page-hero">
//         <div className="wrap">
//           <p className="section-label reveal">Case Studies</p>
//           <h1 className="section-heading reveal d1" style={{ fontSize: "clamp(44px, 7vw, 80px)", marginBottom: 20 }}>
//             <span className="dim">Work that</span><br />
//             moves businesses.
//           </h1>
//           <p className="reveal d2" style={{ fontSize: 17, fontWeight: 300, color: "var(--text2)", maxWidth: 520, lineHeight: 1.75 }}>
//             Deep dives into the platforms, systems, and automation tools I've engineered for real businesses.
//           </p>
//         </div>
//       </section>

//       <div className="sep" />

//       <section style={{ padding: "80px 0" }}>
//         <div className="wrap">
//           <div className="cs-grid">
//             {PROJECTS.map((p, i) => (
//               <div
//                 key={p.id}
//                 className={`cs-card reveal d${i + 1}`}
//                 onClick={() => { setProject(p.id); setPage("detail"); window.scrollTo(0, 0); }}
//               >
//                 <div className="cs-card-banner">
//                   <div className="cs-card-banner-inner" style={{ background: p.gradient, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 80, color: "rgba(255,255,255,0.07)", lineHeight: 1 }}>{p.num}</div>
//                   </div>
//                 </div>
//                 <div className="cs-card-body">
//                   <p className="cs-card-cat">{p.category}</p>
//                   <h3 className="cs-card-title">{p.title}</h3>
//                   <p className="cs-card-desc">{p.desc}</p>
//                   <div className="work-tags">
//                     {p.tags.map((t) => <span key={t} className="tag">{t}</span>)}
//                   </div>
//                   <div style={{ marginTop: 20 }}>
//                     <span className="work-link">
//                       View Case Study
//                       <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <ContactTeaser setPage={setPage} />
//       <Footer setPage={setPage} />
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    DETAIL PAGE
// ───────────────────────────────────────────── */
// function DetailPage({ projectId, setPage }) {
//   const p = PROJECTS.find((x) => x.id === projectId) || PROJECTS[0];
//   useScrollReveal();

//   return (
//     <div className="page">
//       {/* Hero */}
//       <section className="detail-hero" style={{ background: `linear-gradient(180deg, rgba(8,8,16,0) 0%, rgba(8,8,16,0.95) 100%), ${p.gradient}` }}>
//         <div className="wrap">
//           <button className="detail-back" onClick={() => { setPage("case-studies"); window.scrollTo(0, 0); }}>
//             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
//             Back to Work
//           </button>
//           <p className="detail-cat">{p.category}</p>
//           <h1 className="detail-title reveal">{p.title}</h1>
//           <p className="detail-subtitle reveal d1">{p.desc}</p>
//           <div className="detail-meta reveal d2">
//             <div className="detail-meta-item"><label>Type</label><span>{p.category}</span></div>
//             <div className="detail-meta-item"><label>Stack</label><span>{p.tags.join(", ")}</span></div>
//             {p.url !== "#" && (
//               <div className="detail-meta-item">
//                 <label>Live Site</label>
//                 <a href={p.url} target="_blank" rel="noreferrer" style={{ color: "var(--accent)", fontSize: 14, textDecoration: "none", borderBottom: "1px solid rgba(155,93,229,0.3)", paddingBottom: 2 }}>Visit →</a>
//               </div>
//             )}
//           </div>
//         </div>
//       </section>

//       {/* Body */}
//       <div className="detail-body">
//         <div className="wrap-s">
//           {/* Problem */}
//           <div className="detail-section reveal">
//             <p className="detail-section-label">The Problem</p>
//             <h2 className="detail-section-title">What needed solving</h2>
//             <p className="detail-text">{p.problem}</p>
//           </div>

//           {/* Solution */}
//           <div className="detail-section reveal d1">
//             <p className="detail-section-label">The Solution</p>
//             <h2 className="detail-section-title">How I approached it</h2>
//             <p className="detail-text">{p.solution}</p>
//           </div>

//           {/* Features */}
//           <div className="detail-section reveal">
//             <p className="detail-section-label">Key Features</p>
//             <h2 className="detail-section-title">What was built</h2>
//             <div className="detail-features">
//               {p.features.map((f) => (
//                 <div key={f.title} className="detail-feature">
//                   <h3 className="detail-feature-title">{f.title}</h3>
//                   <p className="detail-feature-desc">{f.desc}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Tech Stack */}
//           <div className="detail-section reveal d1">
//             <p className="detail-section-label">Tech Stack</p>
//             <h2 className="detail-section-title">Built with</h2>
//             <div className="work-tags" style={{ marginTop: 20 }}>
//               {p.tags.map((t) => <span key={t} className="tag" style={{ borderColor: `${p.accentColor}33`, color: p.accentColor }}>{t}</span>)}
//             </div>
//           </div>

//           {/* Challenges */}
//           <div className="detail-section reveal">
//             <p className="detail-section-label">Engineering Challenges</p>
//             <h2 className="detail-section-title">The hard parts</h2>
//             <p className="detail-text">{p.challenges}</p>
//           </div>

//           {/* Results */}
//           <div className="detail-section reveal d1">
//             <p className="detail-section-label">Results</p>
//             <h2 className="detail-section-title">What was achieved</h2>
//             <div className="detail-results">
//               {p.results.map((r) => (
//                 <div key={r.label} className="result-pill">
//                   <div className="result-num" style={{ color: p.accentColor }}>{r.num}</div>
//                   <div className="result-text">{r.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Other case studies */}
//       <div className="sep" />
//       <section style={{ padding: "80px 0" }}>
//         <div className="wrap">
//           <p className="section-label reveal">Other Case Studies</p>
//           <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 20, marginTop: 36 }}>
//             {PROJECTS.filter((x) => x.id !== p.id).map((op) => (
//               <div
//                 key={op.id}
//                 className="cs-card reveal"
//                 onClick={() => { setPage("detail"); window.location.search = `?p=${op.id}`; window.scrollTo(0, 0); }}
//               >
//                 <div className="cs-card-banner">
//                   <div className="cs-card-banner-inner" style={{ background: op.gradient, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                     <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 64, color: "rgba(255,255,255,0.07)" }}>{op.num}</div>
//                   </div>
//                 </div>
//                 <div className="cs-card-body">
//                   <p className="cs-card-cat">{op.category}</p>
//                   <h3 className="cs-card-title">{op.title}</h3>
//                   <span className="work-link" style={{ marginTop: 8, display: "inline-flex" }}>
//                     View Case Study
//                     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
//                   </span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <Footer setPage={setPage} />
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    CONTACT PAGE
// ───────────────────────────────────────────── */
// function ContactPage({ setPage }) {
//   const [form, setForm] = useState({ name: "", email: "", message: "" });
//   const [sent, setSent] = useState(false);
//   const [sending, setSending] = useState(false);
//   useScrollReveal();

//   const handleMessage = async (event) => {
//     event.preventDefault();

//     const formData = new FormData(event.target);

//     const name = formData.get("name");
//     const email = formData.get("email");
//     const message = formData.get("message");

//     // Reset form visually
//     event.target.reset();

//     alert("Message sending in Progress");
//     setSending(true);

//     try {
//       const response = await axios.post(
//         "https://portfolio-mailer-19fc.onrender.com/send-mail",
//         {
//           name: name,
//           email: email,
//           message: message,
//         }
//       );

//       setSending(false);
//       if (response.status === 200) {
//         setSent(true);
//         setForm({ name: "", email: "", message: "" });
//         console.log("Status", response.data);
//         alert("Message sent successfully");
//         setTimeout(() => setSent(false), 5000);
//       }
//     } catch (error) {
//       setSending(false);
//       console.error("Error sending email:", error);
//       alert("Failed to send message");
//     }
//   };

//   return (
//     <div className="page">
//       <section className="contact-section">
//         <div className="contact-glow" />

//         <div className="wrap-s" style={{ position: "relative", zIndex: 1 }}>
//           <div className="contact-title reveal">
//             <span className="dim">Get</span> in <span className="accent">Touch.</span>
//           </div>
//           <p className="contact-sub reveal d1">
//             So that we can talk about your project...
//           </p>

//           <div className="contact-icons reveal d2">
//             {[
//               { href: "mailto:yugal@devyugal.in", icon: "✉", label: "Email" },
//               { href: "https://wa.me/+919837114001", icon: "💬", label: "WhatsApp" },
//               { href: "https://github.com", icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>, label: "GitHub" },
//               { href: "https://linkedin.com", icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>, label: "LinkedIn" },
//             ].map((s) => (
//               <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="contact-icon-btn" title={s.label}>
//                 {typeof s.icon === "string" ? s.icon : s.icon}
//               </a>
//             ))}
//           </div>

//           <div className="contact-email reveal d2">
//             <a href="mailto:yugal@devyugal.in">yugal@devyugal.in</a>
//           </div>

//           <form
//             id="messageForm"
//             className="contact-form reveal d3"
//             onSubmit={handleMessage}
//             autoComplete="off"
//           >
//             <h3
//               style={{
//                 fontFamily: "'DM Serif Display', serif",
//                 fontSize: 28,
//                 color: "var(--text1)",
//                 marginBottom: 32,
//                 letterSpacing: "-0.01em",
//                 textAlign: "left",
//               }}
//             >
//               Shoot me a message.
//             </h3>

//             {sent && (
//               <div
//                 style={{
//                   padding: "14px 18px",
//                   borderRadius: 10,
//                   background: "rgba(34,197,94,0.08)",
//                   border: "1px solid rgba(34,197,94,0.2)",
//                   color: "#4ade80",
//                   fontSize: 14,
//                   marginBottom: 24,
//                 }}
//               >
//                 ✓ Message sent — I'll reply within 24 hours.
//               </div>
//             )}

//             <div className="form-group">
//               <label className="form-label">Your Name</label>
//               <input
//                 className="form-input"
//                 name="name"
//                 placeholder="Yugal Raj"
//                 value={form.name}
//                 onChange={e => setForm({ ...form, name: e.target.value })}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <label className="form-label">Email Address</label>
//               <input
//                 className="form-input"
//                 type="email"
//                 name="email"
//                 placeholder="you@email.com"
//                 value={form.email}
//                 onChange={e => setForm({ ...form, email: e.target.value })}
//                 required
//               />
//             </div>
//             <div className="form-group">
//               <label className="form-label">Your Message</label>
//               <textarea
//                 className="form-input"
//                 name="message"
//                 placeholder="Tell me about your project..."
//                 value={form.message}
//                 onChange={e => setForm({ ...form, message: e.target.value })}
//                 required
//               />
//             </div>
//             <button
//               className="btn-primary form-submit"
//               type="submit"
//               disabled={sending}
//               style={sending ? { opacity: 0.6, pointerEvents: "none" } : undefined}
//             >
//               {sending ? (
//                 <>
//                   Sending...
//                 </>
//               ) : (
//                 <>
//                   Send Message
//                   <svg
//                     width="14"
//                     height="14"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path d="M5 12h14M12 5l7 7-7 7" />
//                   </svg>
//                 </>
//               )}
//             </button>
//           </form>
//         </div>
//       </section>

//       <footer className="footer">
//         <div className="footer-inner">
//           <span className="footer-copy">© 2025 Yugal Raj Vimal · devyugal.in</span>
//           <span className="footer-copy">Made with care ♥</span>
//         </div>
//       </footer>
//     </div>
//   );
// }

// /* ─────────────────────────────────────────────
//    APP ROOT
// ───────────────────────────────────────────── */
// export default function Home() {
//   const [page, setPage] = useState("home");
//   const [projectId, setProjectId] = useState("nupal-cdc");

//   const render = () => {
//     switch (page) {
//       case "home":         return <HomePage setPage={setPage} setProject={setProjectId} />;
//       case "case-studies": return <CaseStudiesPage setPage={setPage} setProject={setProjectId} />;
//       case "detail":       return <DetailPage projectId={projectId} setPage={setPage} />;
//       case "contact":      return <ContactPage setPage={setPage} />;
//       default:             return <HomePage setPage={setPage} setProject={setProjectId} />;
//     }
//   };

//   return (
//     <>
//       <Styles />
//       <Nav page={page} setPage={setPage} />
//       {render()}
//     </>
//   );
// }

import React,{ useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";


/* ─────────────────────────────────────────────
   FONT + GLOBAL STYLES
───────────────────────────────────────────── */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,200;0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,300&family=DM+Serif+Display:ital@0;1&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    :root {
      --black:   #080810;
      --bg:      #0a0a12;
      --bg2:     #0f0f1a;
      --border:  rgba(255,255,255,0.06);
      --border2: rgba(255,255,255,0.12);
      --text1:   #f4f4f6;
      --text2:   rgba(244,244,246,0.5);
      --text3:   rgba(244,244,246,0.28);
      --purple:  #9b5de5;
      --purple2: #c77dff;
      --pink:    #e040fb;
      --accent:  #b06dff;
    }

    html { scroll-behavior: smooth; }

    body {
      background: var(--bg);
      color: var(--text1);
      font-family: 'DM Sans', -apple-system, sans-serif;
      -webkit-font-smoothing: antialiased;
      overflow-x: hidden;
    }

    /* ── Scrollbar ── */
    ::-webkit-scrollbar { width: 4px; }
    ::-webkit-scrollbar-track { background: var(--bg); }
    ::-webkit-scrollbar-thumb { background: rgba(155,93,229,0.4); border-radius: 2px; }
    ::selection { background: rgba(155,93,229,0.35); }

    /* ── Animations ── */
    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(28px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes fadeIn {
      from { opacity: 0; } to { opacity: 1; }
    }
    @keyframes marquee {
      from { transform: translateX(0); }
      to   { transform: translateX(-50%); }
    }
    @keyframes blink {
      0%, 100% { opacity: 1; }
      50% { opacity: 0; }
    }
    @keyframes float {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-10px); }
    }
    @keyframes glow-pulse {
      0%, 100% { opacity: 0.15; transform: scale(1); }
      50% { opacity: 0.28; transform: scale(1.06); }
    }
    @keyframes floatCard1 {
      0%, 100% { transform: translateY(0px) rotate(-1deg); }
      50% { transform: translateY(-14px) rotate(-1deg); }
    }
    @keyframes floatCard2 {
      0%, 100% { transform: translateY(0px) rotate(1.5deg); }
      50% { transform: translateY(-10px) rotate(1.5deg); }
    }
    @keyframes floatCard3 {
      0%, 100% { transform: translateY(0px) rotate(-0.5deg); }
      50% { transform: translateY(-18px) rotate(-0.5deg); }
    }
    @keyframes barGrow {
      from { transform: scaleY(0); }
      to { transform: scaleY(1); }
    }
    @keyframes countUp {
      from { opacity: 0; transform: translateY(6px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes shimmer {
      0% { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
    @keyframes toastSlide {
      from { opacity: 0; transform: translateY(16px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    /* ── Hero Visual ── */
  .hero-visual {
  position: relative;
  width: 42%; min-width: 340px; max-width: 480px;
  flex-shrink: 0;
  display: flex; flex-direction: column; gap: 12px;
  z-index: 1;
}
    .hv-card {
      background: rgba(15,15,26,0.9);
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 16px; padding: 18px 20px;
      backdrop-filter: blur(12px);
      box-shadow: 0 8px 32px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.05);
    }
    .hv-card1 { animation: floatCard1 6s ease-in-out infinite; }
    .hv-card2 { animation: floatCard2 7s ease-in-out infinite 0.8s; }
    .hv-card3 { animation: floatCard3 5.5s ease-in-out infinite 1.5s; }
    .hv-label { font-size: 10px; letter-spacing: 0.12em; text-transform: uppercase; color: rgba(244,244,246,0.35); margin-bottom: 10px; }
    .hv-value { font-family: 'DM Serif Display', serif; font-size: 28px; color: var(--text1); letter-spacing: -0.02em; line-height: 1; }
    .hv-sub { font-size: 11px; color: rgba(155,93,229,0.8); margin-top: 4px; }
    .hv-bars { display: flex; align-items: flex-end; gap: 5px; height: 40px; margin-top: 10px; }
    .hv-bar {
      flex: 1; border-radius: 3px 3px 0 0;
      background: rgba(155,93,229,0.25); transform-origin: bottom;
      animation: barGrow 1.2s cubic-bezier(.22,.68,0,1.1) both;
    }
    .hv-bar.active { background: linear-gradient(to top, #7c3aed, #c77dff); }
    .hv-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
    .hv-row:last-child { margin-bottom: 0; }
    .hv-row-label { font-size: 12px; color: rgba(244,244,246,0.45); }
    .hv-row-val { font-size: 12px; font-weight: 500; color: var(--text1); }
    .hv-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--accent); display: inline-block; margin-right: 7px; }
    .hv-dot.green { background: #4ade80; }
    .hv-dot.orange { background: #fb923c; }
    .hv-chip {
      display: inline-flex; align-items: center; gap: 6px;
      padding: 4px 10px; border-radius: 100px;
      background: rgba(74,222,128,0.1); border: 1px solid rgba(74,222,128,0.2);
      font-size: 11px; color: #4ade80;
    }
    @media (max-width: 900px) {
      .hero-visual { display: none; }
    }

    /* ── Reveal ── */
    .reveal {
      opacity: 0;
      transform: translateY(24px);
      transition: opacity 0.8s cubic-bezier(.22,.68,0,1.1), transform 0.8s cubic-bezier(.22,.68,0,1.1);
    }
    .reveal.in { opacity: 1; transform: translateY(0); }
    .reveal.d1 { transition-delay: 0.08s; }
    .reveal.d2 { transition-delay: 0.16s; }
    .reveal.d3 { transition-delay: 0.24s; }
    .reveal.d4 { transition-delay: 0.32s; }
    .reveal.d5 { transition-delay: 0.40s; }

    /* ── Shared Layout ── */
    .wrap   { max-width: 1100px; margin: 0 auto; padding: 0 40px; }
    .wrap-s { max-width: 840px;  margin: 0 auto; padding: 0 40px; }

    /* ── Nav ── */
    .nav {
      position: fixed; top: 0; left: 0; right: 0; z-index: 200;
      padding: 28px 0;
      transition: all 0.4s ease;
    }
    .nav.stuck {
      padding: 18px 0;
      background: rgba(10,10,18,0.88);
      backdrop-filter: blur(20px);
      border-bottom: 1px solid var(--border);
    }
    .nav-inner {
      max-width: 1100px; margin: 0 auto; padding: 0 40px;
      display: flex; align-items: center; justify-content: space-between;
    }
    .logo {
      font-family: 'DM Serif Display', serif;
      font-size: 22px; color: var(--text1);
      cursor: pointer; letter-spacing: -0.01em;
    }
    .logo span { color: var(--accent); }
    .nav-links { display: flex; align-items: center; gap: 36px; }
    .nav-link {
      font-size: 13.5px; font-weight: 400; letter-spacing: 0.02em;
      color: rgba(244,244,246,0.65); cursor: pointer;
      transition: color 0.2s; text-transform: uppercase;
      position: relative;
    }
    .nav-link::after {
      content: ''; position: absolute; bottom: -3px; left: 0; right: 0;
      height: 1px; background: var(--accent);
      transform: scaleX(0); transform-origin: left;
      transition: transform 0.25s cubic-bezier(.22,.68,0,1.1);
    }
    .nav-link:hover { color: var(--text1); }
    .nav-link:hover::after { transform: scaleX(1); }
    .nav-link.active { color: var(--text1); }
    .nav-link.active::after { transform: scaleX(1); }
    .nav-cta {
      font-size: 13px; font-weight: 500; padding: 9px 22px;
      border: 1px solid var(--border2); border-radius: 100px;
      color: var(--text1); background: transparent;
      cursor: pointer; transition: all 0.25s;
      letter-spacing: 0.01em;
    }
    .nav-cta:hover { background: rgba(155,93,229,0.12); border-color: var(--accent); color: var(--accent); }

    /* ── Hamburger ── */
    .hamburger {
      display: none; flex-direction: column; gap: 5px; cursor: pointer;
      width: 28px; padding: 4px 0;
    }
    .hamburger span {
      display: block; height: 1.5px; background: var(--text1);
      transition: all 0.3s ease; border-radius: 2px;
    }
    .hamburger.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
    .hamburger.open span:nth-child(2) { opacity: 0; }
    .hamburger.open span:nth-child(3) { transform: rotate(-45deg) translate(5px, -5px); }

    .mobile-menu {
      position: fixed; inset: 0; z-index: 199;
      background: rgba(8,8,16,0.98); backdrop-filter: blur(24px);
      display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 44px;
      animation: fadeIn 0.25s ease;
    }
    .mobile-nav-link {
      font-family: 'DM Serif Display', serif;
      font-size: 42px; color: var(--text2); cursor: pointer;
      transition: color 0.2s;
    }
    .mobile-nav-link:hover { color: var(--text1); }

    /* ── Hero ── */
    .hero {
      display: flex; align-items: center; justify-content: flex-start;
      text-align: left; position: relative; overflow: hidden;
      padding: 120px 40px 80px;
      min-height: 100vh;
    }
   .hero-content { max-width: 580px; position: relative; z-index: 1; }
    .hero-glow {
      position: absolute; border-radius: 50%; pointer-events: none; filter: blur(100px);
      animation: glow-pulse 8s ease-in-out infinite;
    }
    .hero-eyebrow {
      display: inline-flex; align-items: center; gap: 10px;
      font-size: 12px; font-weight: 500; letter-spacing: 0.15em;
      text-transform: uppercase; color: var(--text3); margin-bottom: 36px;
    }
    .hero-eyebrow::before {
      content: ''; width: 32px; height: 1px; background: var(--border2);
    }
    @media (max-width: 900px) {
      .hero-eyebrow::before {
        display: none;
      }
    }
    .hero-title {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(44px, 6vw, 88px);
      line-height: 1.04; letter-spacing: -0.02em;
      color: var(--text1); margin-bottom: 28px;
    }
    .hero-title .light { color: var(--text2); font-style: italic; }
    .hero-title .accent { color: var(--accent); }
    .hero-sub {
      font-size: clamp(15px, 1.8vw, 18px); font-weight: 300;
      color: var(--text2); line-height: 1.75;
      max-width: 460px; margin: 0 0 52px;
    }
    .hero-actions { display: flex; gap: 16px; flex-wrap: wrap; }
    .btn-primary {
      display: inline-flex; align-items: center; gap: 8px;
      padding: 14px 30px; border-radius: 100px;
      background: linear-gradient(135deg, #7c3aed, #a855f7);
      color: white; font-size: 14px; font-weight: 500;
      border: none; cursor: pointer; transition: all 0.3s;
      box-shadow: 0 0 28px rgba(124,58,237,0.3);
    }
    .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 0 44px rgba(124,58,237,0.5); }
    .btn-outline {
      display: inline-flex; align-items: center; gap: 8px;
      padding: 13px 28px; border-radius: 100px;
      border: 1px solid var(--border2); background: transparent;
      color: var(--text1); font-size: 14px; font-weight: 400;
      cursor: pointer; transition: all 0.3s;
    }
    .btn-outline:hover { border-color: rgba(155,93,229,0.5); background: rgba(155,93,229,0.06); }
    .scroll-hint {
      position: absolute; bottom: 15px; left: 40px;
      display: flex; align-items: center; gap: 10px;
      color: var(--text3); font-size: 11px; letter-spacing: 0.15em; text-transform: uppercase;
    }
    .scroll-arrow {
      width: 36px; height: 1px; background: linear-gradient(to right, var(--text3), transparent);
    }
    @media (max-width: 900px) {
      .hero { text-align: center; justify-content: center; min-height: auto; padding: 120px 24px 80px; }
      .hero-content { max-width: 100%; }
      .hero-eyebrow { justify-content: center; }
      .hero-sub { margin: 0 auto 52px; }
      .hero-actions { justify-content: center; }
      .scroll-hint { left: 50%; transform: translateX(-50%); flex-direction: column; gap: 8px; }
      .scroll-arrow { width: 1px; height: 28px; background: linear-gradient(to bottom, var(--text3), transparent); }
    }

    /* ── Section separator ── */
    .sep { height: 1px; background: var(--border); margin: 0; }

    /* ── Clients / Marquee ── */
    .clients-section { padding: 80px 0; }
    .clients-label {
      font-size: 13px; font-weight: 300; color: var(--text3);
      letter-spacing: 0.06em; margin-bottom: 48px; padding: 0 40px;
    }
    .clients-label strong { color: var(--text2); font-weight: 500; }
    .marquee-wrap { overflow: hidden; }
    .marquee-track {
      display: flex; width: max-content;
      animation: marquee 32s linear infinite;
    }
    .marquee-track:hover { animation-play-state: paused; }
    .client-item {
      display: flex; align-items: center; gap: 10px;
      padding: 0 44px; opacity: 0.3;
      font-size: 15px; font-weight: 500; letter-spacing: 0.04em;
      color: var(--text1); white-space: nowrap;
      transition: opacity 0.3s; cursor: default;
    }
    .client-item:hover { opacity: 0.7; }
    .client-dot { width: 5px; height: 5px; border-radius: 50%; background: var(--accent); }

    /* ── Work Section ── */
    .work-section { padding: 100px 0; }
    .section-label {
      font-size: 12px; font-weight: 500; letter-spacing: 0.14em;
      text-transform: uppercase; color: var(--text3); margin-bottom: 16px;
    }
    .section-heading {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(36px, 5vw, 60px); line-height: 1.08;
      letter-spacing: -0.02em; color: var(--text1);
    }
    .section-heading .dim { color: var(--text2); font-style: italic; }

    /* Work items — alternating layout */
    .work-list { display: flex; flex-direction: column; gap: 0; }
    .work-item {
      display: grid; grid-template-columns: 1fr 1fr;
      gap: 0; align-items: center;
      padding: 80px 0; border-bottom: 1px solid var(--border);
      cursor: pointer;
    }
    .work-item:last-child { border-bottom: none; }
    .work-item.flip { direction: rtl; }
    .work-item.flip > * { direction: ltr; }
    .work-img {
      aspect-ratio: 16/10; border-radius: 16px; overflow: hidden;
      position: relative;
      background: var(--bg2);
      border: 1px solid var(--border);
    }
    .work-img-inner {
      width: 100%; height: 100%;
      transition: transform 0.6s cubic-bezier(.22,.68,0,1.1);
      display: flex; align-items: center; justify-content: center;
    }
    .work-item:hover .work-img-inner { transform: scale(1.04); }
    .work-img-placeholder {
      width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
      font-size: 13px; color: var(--text3); letter-spacing: 0.08em;
    }
    .work-info { padding: 0 60px; }
    .work-item.flip .work-info { padding: 0 60px 0 0; }
    .work-category {
      font-size: 11px; font-weight: 500; letter-spacing: 0.14em;
      text-transform: uppercase; color: var(--accent); margin-bottom: 16px;
    }
    .work-title {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(28px, 3.5vw, 44px); line-height: 1.1;
      letter-spacing: -0.02em; color: var(--text1); margin-bottom: 18px;
    }
    .work-desc {
      font-size: 15px; font-weight: 300; color: var(--text2);
      line-height: 1.78; margin-bottom: 28px; max-width: 380px;
    }
    .work-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 32px; }
    .tag {
      font-size: 11px; font-weight: 500; padding: 5px 14px;
      border-radius: 100px; border: 1px solid var(--border2);
      color: var(--text3); letter-spacing: 0.04em;
    }
    .work-link {
      display: inline-flex; align-items: center; gap: 8px;
      font-size: 13px; font-weight: 500; color: var(--text1);
      letter-spacing: 0.04em; text-transform: uppercase;
      border-bottom: 1px solid var(--border2); padding-bottom: 2px;
      transition: all 0.25s; cursor: pointer;
    }
    .work-link:hover { color: var(--accent); border-color: var(--accent); gap: 14px; }
    .work-num {
      position: absolute; top: 20px; left: 24px;
      font-size: 11px; color: var(--text3); letter-spacing: 0.08em;
    }

    /* ── About ── */
    .about-section { padding: 100px 0; }
    .about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
    .about-label { font-size: 11px; font-weight: 500; letter-spacing: 0.14em; text-transform: uppercase; color: var(--text3); margin-bottom: 24px; }
    .about-text {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(24px, 3vw, 38px); line-height: 1.35;
      letter-spacing: -0.01em; color: var(--text1); margin-bottom: 28px;
    }
    .about-text .dim { color: var(--text2); }
    .about-text em { color: var(--accent); font-style: italic; }
    .about-body { font-size: 15px; font-weight: 300; color: var(--text2); line-height: 1.82; margin-bottom: 36px; }
    .about-stats { display: flex; gap: 36px; }
    .stat-num {
      font-family: 'DM Serif Display', serif;
      font-size: 42px; letter-spacing: -0.02em; color: var(--text1); line-height: 1;
    }
    .stat-label { font-size: 12px; color: var(--text3); margin-top: 4px; letter-spacing: 0.04em; }
    .about-visual { display: flex; flex-direction: column; gap: 16px; }
    .tech-section-inner {
      background: var(--bg2); border: 1px solid var(--border);
      border-radius: 16px; padding: 28px;
    }
    .tech-section-title { font-size: 11px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--text3); margin-bottom: 18px; }
    .tech-grid { display: flex; flex-wrap: wrap; gap: 8px; }
    .tech-pill {
      font-size: 12px; font-weight: 400; padding: 6px 14px;
      border-radius: 100px; border: 1px solid var(--border);
      color: var(--text2); background: transparent;
      transition: all 0.25s; cursor: default;
    }
    .tech-pill:hover { border-color: rgba(155,93,229,0.4); color: var(--text1); background: rgba(155,93,229,0.06); }

    /* ── Services ── */
    .services-section { padding: 100px 0; }
    .services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px; background: var(--border); border: 1px solid var(--border); border-radius: 16px; overflow: hidden; margin-top: 64px; }
    .service-card { padding: 36px 32px; background: var(--bg); transition: background 0.3s; }
    .service-card:hover { background: var(--bg2); }
    .service-num { font-size: 11px; color: var(--text3); letter-spacing: 0.08em; margin-bottom: 20px; }
    .service-icon { font-size: 22px; margin-bottom: 16px; }
    .service-title { font-size: 16px; font-weight: 500; color: var(--text1); margin-bottom: 10px; line-height: 1.3; }
    .service-desc { font-size: 13px; font-weight: 300; color: var(--text3); line-height: 1.7; }

    /* ── Contact ── */
    .contact-section {
      padding: 160px 0 100px; text-align: center; position: relative; overflow: hidden;
    }
    .contact-glow {
      position: absolute; width: 600px; height: 600px; border-radius: 50%;
      background: radial-gradient(ellipse, rgba(124,58,237,0.12), transparent 70%);
      top: 50%; left: 50%; transform: translate(-50%, -50%); pointer-events: none;
    }
    .contact-title {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(52px, 10vw, 120px); line-height: 1;
      letter-spacing: -0.03em; position: relative; z-index: 1;
      margin-bottom: 24px;
    }
    .contact-title .dim { color: var(--text2); }
    .contact-title .accent { color: var(--accent); }
    .contact-sub { font-size: 16px; font-weight: 300; color: var(--text3); margin-bottom: 36px; position: relative; z-index: 1; }
    .contact-trust {
      display: flex; gap: 12px; justify-content: center; flex-wrap: wrap;
      margin-bottom: 44px; position: relative; z-index: 1;
    }
    .trust-pill {
      display: inline-flex; align-items: center; gap: 7px;
      padding: 7px 16px; border-radius: 100px;
      border: 1px solid var(--border); background: rgba(255,255,255,0.02);
      font-size: 12px; color: rgba(244,244,246,0.5); letter-spacing: 0.02em;
    }
    .trust-dot { width: 6px; height: 6px; border-radius: 50%; background: #4ade80; flex-shrink: 0; }
    .contact-icons { display: flex; gap: 20px; justify-content: center; margin-bottom: 60px; position: relative; z-index: 1; flex-wrap: wrap; }
    .contact-icon-btn {
      width: 52px; height: 52px; border-radius: 50%;
      border: 1px solid var(--border2); background: transparent;
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; transition: all 0.3s; font-size: 18px; color: var(--text2);
      text-decoration: none;
    }
    .contact-icon-btn:hover { border-color: var(--accent); background: rgba(155,93,229,0.1); color: var(--text1); transform: translateY(-3px); }
    .contact-email {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(16px, 2.5vw, 22px); color: var(--text2);
      position: relative; z-index: 1; letter-spacing: -0.01em;
    }
    .contact-email a { color: inherit; text-decoration: none; border-bottom: 1px solid var(--border2); padding-bottom: 2px; transition: all 0.25s; }
    .contact-email a:hover { color: var(--text1); border-color: var(--accent); }

    /* ── Contact Form ── */
    .contact-form { max-width: 480px; margin: 52px auto 0; text-align: left; position: relative; z-index: 1; }
    .form-group { margin-bottom: 20px; }
    .form-label { font-size: 11px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--text3); display: block; margin-bottom: 10px; }
    .form-input {
      width: 100%; padding: 14px 18px; border-radius: 10px;
      border: 1px solid var(--border); background: rgba(255,255,255,0.03);
      color: var(--text1); font-size: 14px; font-family: 'DM Sans', sans-serif;
      outline: none; transition: border-color 0.25s;
    }
    .form-input:focus { border-color: rgba(155,93,229,0.5); background: rgba(155,93,229,0.04); }
    .form-input::placeholder { color: var(--text3); }
    textarea.form-input { resize: vertical; min-height: 120px; line-height: 1.6; }
    .form-submit { width: 100%; margin-top: 8px; padding: 15px; border-radius: 10px; }

    /* ── Footer ── */
    .footer { padding: 32px 0; border-top: 1px solid var(--border); }
    .footer-inner {
      max-width: 1100px; margin: 0 auto; padding: 0 40px;
      display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;
    }
    .footer-copy { font-size: 12px; color: var(--text3); letter-spacing: 0.04em; }
    .footer-links { display: flex; gap: 24px; }
    .footer-link { font-size: 12px; color: var(--text3); cursor: pointer; transition: color 0.2s; letter-spacing: 0.04em; }
    .footer-link:hover { color: var(--text2); }

    /* ── Toast notification ── */
    .toast {
      position: fixed; bottom: 32px; left: 50%; transform: translateX(-50%);
      z-index: 999; padding: 14px 22px; border-radius: 12px;
      display: flex; align-items: center; gap: 10px;
      font-size: 14px; font-weight: 400; letter-spacing: 0.01em;
      animation: toastSlide 0.3s ease both;
      box-shadow: 0 8px 32px rgba(0,0,0,0.5);
      white-space: nowrap;
    }
    .toast.success { background: rgba(15,25,15,0.95); border: 1px solid rgba(74,222,128,0.3); color: #4ade80; }
    .toast.error   { background: rgba(25,10,10,0.95); border: 1px solid rgba(239,68,68,0.3); color: #f87171; }
    .toast.info    { background: rgba(10,10,20,0.95); border: 1px solid rgba(155,93,229,0.3); color: var(--accent); }

    /* ── Glow card hover ── */
    .glow-card {
      position: relative; overflow: hidden;
    }
    .glow-card::before {
      content: ''; position: absolute; inset: 0; border-radius: inherit;
      background: radial-gradient(400px circle at var(--mx, 50%) var(--my, 50%), rgba(155,93,229,0.08), transparent 60%);
      opacity: 0; transition: opacity 0.3s; pointer-events: none; z-index: 0;
    }
    .glow-card:hover::before { opacity: 1; }

    /* ── Page transitions ── */
    .page { animation: fadeIn 0.5s ease; }

    /* ── Case Studies Page ── */
    .cs-page-hero { padding: 160px 0 80px; }
    .cs-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(340px, 1fr)); gap: 24px; margin-top: 64px; }
    .cs-card {
      background: var(--bg2); border: 1px solid var(--border);
      border-radius: 20px; overflow: hidden; cursor: pointer;
      transition: border-color 0.3s, transform 0.4s cubic-bezier(.22,.68,0,1.1);
    }
    .cs-card:hover { border-color: rgba(155,93,229,0.3); transform: translateY(-6px); }
    .cs-card-banner { height: 200px; position: relative; overflow: hidden; }
    .cs-card-banner-inner { width: 100%; height: 100%; transition: transform 0.6s cubic-bezier(.22,.68,0,1.1); }
    .cs-card:hover .cs-card-banner-inner { transform: scale(1.05); }
    .cs-card-body { padding: 28px; }
    .cs-card-cat { font-size: 11px; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: var(--accent); margin-bottom: 10px; }
    .cs-card-title { font-family: 'DM Serif Display', serif; font-size: 24px; letter-spacing: -0.01em; color: var(--text1); margin-bottom: 12px; line-height: 1.2; }
    .cs-card-desc { font-size: 14px; font-weight: 300; color: var(--text2); line-height: 1.72; margin-bottom: 20px; }

    /* ── Detail Page ── */
    .detail-hero { padding: 140px 0 80px; border-bottom: 1px solid var(--border); }
    .detail-back {
      display: inline-flex; align-items: center; gap: 8px;
      font-size: 12px; letter-spacing: 0.1em; text-transform: uppercase;
      color: var(--text3); cursor: pointer; margin-bottom: 48px;
      transition: color 0.2s; border: none; background: none;
    }
    .detail-back:hover { color: var(--text2); }
    .detail-cat { font-size: 12px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--accent); margin-bottom: 20px; }
    .detail-title {
      font-family: 'DM Serif Display', serif;
      font-size: clamp(40px, 7vw, 80px); line-height: 1.06;
      letter-spacing: -0.03em; margin-bottom: 24px;
    }
    .detail-subtitle { font-size: 18px; font-weight: 300; color: var(--text2); line-height: 1.7; max-width: 560px; margin-bottom: 40px; }
    .detail-meta { display: flex; gap: 48px; flex-wrap: wrap; }
    .detail-meta-item label { font-size: 10px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--text3); display: block; margin-bottom: 6px; }
    .detail-meta-item span { font-size: 14px; font-weight: 400; color: var(--text2); }
    .detail-body { padding: 80px 0; }
    .detail-section { margin-bottom: 72px; }
    .detail-section-label { font-size: 11px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--accent); margin-bottom: 20px; }
    .detail-section-title { font-family: 'DM Serif Display', serif; font-size: 32px; letter-spacing: -0.02em; color: var(--text1); margin-bottom: 20px; }
    .detail-text { font-size: 15px; font-weight: 300; color: var(--text2); line-height: 1.85; }
    .detail-features { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 28px; }
    .detail-feature {
      padding: 24px; border-radius: 12px;
      border: 1px solid var(--border); background: var(--bg2);
    }
    .detail-feature-title { font-size: 14px; font-weight: 500; color: var(--text1); margin-bottom: 8px; }
    .detail-feature-desc { font-size: 13px; font-weight: 300; color: var(--text3); line-height: 1.65; }
    .detail-results { display: flex; gap: 20px; flex-wrap: wrap; margin-top: 28px; }
    .result-pill {
      padding: 16px 24px; border-radius: 12px;
      border: 1px solid rgba(155,93,229,0.2); background: rgba(155,93,229,0.06);
    }
    .result-num { font-family: 'DM Serif Display', serif; font-size: 32px; color: var(--accent); line-height: 1; }
    .result-text { font-size: 12px; color: var(--text3); margin-top: 6px; letter-spacing: 0.04em; }

    /* ── Responsive ── */
    @media (max-width: 900px) {
      .nav-links { display: none; }
      .hamburger { display: flex; }
      .wrap { padding: 0 24px; }
      .wrap-s { padding: 0 24px; }
      .work-item { grid-template-columns: 1fr; padding: 56px 0; gap: 36px; }
      .work-item.flip { direction: ltr; }
      .work-info { padding: 0 !important; }
      .about-grid { grid-template-columns: 1fr; gap: 48px; }
      .services-grid { grid-template-columns: 1fr 1fr; }
      .detail-features { grid-template-columns: 1fr; }
      .cs-grid { grid-template-columns: 1fr; }
    }
    @media (max-width: 600px) {
      .hero-title { font-size: clamp(38px, 11vw, 60px); }
      .services-grid { grid-template-columns: 1fr; }
      .about-stats { gap: 24px; }
      .nav-cta { display: none; }
      .detail-meta { gap: 24px; }
      .detail-results { flex-direction: column; }
    }
  `}</style>
);

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const PROJECTS = [
  {
    id: "nupal-cdc",
    num: "01",
    category: "Healthcare SaaS",
    title: "Nupal CDC",
    subtitle: "Therapy Clinic Platform",
    desc: "A comprehensive therapy clinic management platform featuring appointment scheduling, therapist availability management, patient records, payment processing, and automated workflow systems.",
    tags: ["Next.js", "Node.js", "MongoDB", "Stripe"],
    url: "https://booking.nupalcdc.com/",
    gradient: "linear-gradient(135deg, #0d1b4b 0%, #1a3a8f 50%, #4f46e5 100%)",
    accentColor: "#6366f1",
    problem: "The clinic managed appointments via phone calls and paper diaries — leading to double bookings, missed reminders, and no consolidated patient history.",
    solution: "Delivered a fully integrated clinic platform with online booking, therapist calendar management, patient EHR, payments, and automated reminder workflows.",
    features: [
      { title: "Online Booking Portal", desc: "Patients book appointments 24/7 with real-time availability." },
      { title: "Therapist Calendars", desc: "Each therapist manages their own schedule and availability." },
      { title: "Patient History", desc: "Session notes, treatment history, and progress tracking." },
      { title: "Payment Integration", desc: "Stripe-powered billing with invoices and receipts." },
      { title: "Automated Reminders", desc: "SMS and email reminders reduce no-shows significantly." },
      { title: "Staff Dashboard", desc: "Role-based access for admins, therapists, and reception." },
    ],
    results: [
      { num: "300+", label: "Monthly bookings" },
      { num: "0", label: "Double bookings" },
      { num: "4×", label: "Faster admin workflow" },
    ],
    challenges: "Building real-time calendar conflict detection across multiple therapist types while maintaining HIPAA-aligned data practices was the core engineering challenge.",
  },
  {
    id: "dairy-management",
    num: "02",
    category: "Business Automation",
    title: "Dholpur Fresh",
    subtitle: "Dairy Management System",
    desc: "A multi-role vendor and reporting management system with automation workflows, Excel processing, asset tracking, and API integration — eliminating 100% of manual spreadsheet operations.",
    tags: ["React", "Node.js", "PostgreSQL", "Redis"],
    url: "https://dholpurfresh.site/",
    gradient: "linear-gradient(135deg, #1a0533 0%, #3b0764 50%, #7c3aed 100%)",
    accentColor: "#a855f7",
    problem: "40+ vendors managed via fragmented WhatsApp messages and Excel files, with no audit trail, frequent errors, and days-long report generation cycles.",
    solution: "A unified multi-role SaaS platform with vendor portals, automated pipelines, real-time dashboards, and zero manual Excel dependency.",
    features: [
      { title: "Multi-Role Access", desc: "Admin, Vendor, and Staff portals with distinct permissions." },
      { title: "Excel Automation", desc: "Automated import/export of operational data." },
      { title: "Live Dashboards", desc: "Real-time sales, payments, and vendor metrics." },
      { title: "Asset Tracking", desc: "End-to-end lifecycle management of physical assets." },
      { title: "Invoice Generation", desc: "Automated PDF invoices sent on trigger events." },
      { title: "API Integrations", desc: "Third-party connections for payments and logistics." },
    ],
    results: [
      { num: "60%", label: "Faster reporting" },
      { num: "40+", label: "Vendors managed" },
      { num: "100%", label: "Manual work eliminated" },
    ],
    challenges: "Migrating 3 years of Excel data without loss while building a real-time vendor sync system across unstable mobile connections.",
  },
  {
    id: "auto-daddy",
    num: "03",
    category: "Marketplace Platform",
    title: "Auto Daddy",
    subtitle: "Automotive Services Platform",
    desc: "A dual-sided marketplace connecting vehicle owners with service providers — featuring real-time booking, vendor dashboards, job tracking, and a full admin console.",
    tags: ["React Native", "Node.js", "MongoDB", "AWS"],
    url: "#",
    gradient: "linear-gradient(135deg, #1a0a00 0%, #7c2d12 50%, #ea580c 100%)",
    accentColor: "#f97316",
    problem: "Auto service providers had no digital presence. Customers had no reliable way to discover, compare, or book automotive services in their city.",
    solution: "Full marketplace platform — customer app, vendor dashboard, and admin console — enabling seamless discovery, booking, and fulfillment.",
    features: [
      { title: "Customer App", desc: "iOS and Android app for discovering and booking services." },
      { title: "Vendor Dashboard", desc: "Service providers manage listings, bookings, and earnings." },
      { title: "Live Job Tracking", desc: "Real-time status updates throughout the service lifecycle." },
      { title: "In-App Chat", desc: "Direct communication between customers and vendors." },
      { title: "Reviews & Ratings", desc: "Trust-building review system for service quality." },
      { title: "Admin Console", desc: "Full operational oversight and dispute management." },
    ],
    results: [
      { num: "3", label: "Cities launched" },
      { num: "120+", label: "Service providers" },
      { num: "2-sided", label: "Marketplace live" },
    ],
    challenges: "Real-time location-based vendor discovery with a complex booking state machine that handles cancellations, reschedules, and partial completions.",
  },
];

const OTHER_PROJECTS = [
  { name: "B.S. Advertising Co.", category: "Web App", desc: "CRM & property listing platform", url: "https://hariomrealest.com/" },
  { name: "Hariom Properties", category: "Web App", desc: "Real estate management system", url: "https://hariomprop.com/" },
  { name: "Sudhoshan Skills", category: "Web + CMS", desc: "Skill training platform with CMS", url: "https://sudhosanskillsolutions.in/" },
  { name: "RJ Solar Panels", category: "Website", desc: "Solar energy company site", url: "#" },
  { name: "Sharda Clinic", category: "Website", desc: "Medical clinic & appointments", url: "#" },
  { name: "Vanrang Foundation", category: "Website", desc: "NGO & charity platform", url: "#" },
];

const CLIENTS = [
  "Nupal CDC", "Dholpur Fresh", "Auto Daddy", "Hariom Properties",
  "B.S. Advertising", "RJ Solar", "Sudhoshan Skills", "Sharda Clinic",
  "Vanrang Foundation", "GoWappily", "Smile Dental", "Astro Academy",
];

const SERVICES = [
  { num: "01", icon: "⚙️", title: "Custom Business Software", desc: "Bespoke systems that fit your exact workflow — not off-the-shelf compromises." },
  { num: "02", icon: "📊", title: "Dashboards & Admin Systems", desc: "Real-time, data-rich dashboards and internal tools your team actually uses." },
  { num: "03", icon: "🌐", title: "Full Stack Web Development", desc: "End-to-end web apps from architecture to production deployment." },
  { num: "04", icon: "🔌", title: "API & Backend Development", desc: "Scalable REST APIs, microservices, and backend architectures." },
  { num: "05", icon: "⚡", title: "Automation Systems", desc: "Eliminate manual work with intelligent, reliable automation pipelines." },
  { num: "06", icon: "🔗", title: "Workflow Solutions", desc: "Map complex business processes to clean, efficient digital systems." },
];

const TECH = {
  Frontend: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion", "GSAP", "Three.js"],
  Backend: ["Node.js", "Express", "MongoDB", "PostgreSQL", "MySQL", "RESTful APIs"],
  Tools: ["Git", "GitHub", "Docker", "AWS EC2", "Render", "Postman", "VS Code"],
};

/* ─────────────────────────────────────────────
   HOOKS
───────────────────────────────────────────── */
function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("in"); }),
      { threshold: 0.08 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  });
}

function useScrolled() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);
  return scrolled;
}

/* ─────────────────────────────────────────────
   NAV
───────────────────────────────────────────── */
export function Nav({ page, setPage }) {
  const scrolled = useScrolled();
  const [open, setOpen] = useState(false);
  const go = (p) => { setPage(p); window.scrollTo(0, 0); setOpen(false); };
  const links = [
    { label: "Work", page: "home", hash: "#work" },
    { label: "Case Studies", page: "case-studies" },
    { label: "About", page: "home", hash: "#about" },
    { label: "Contact", page: "contact" },
  ];

  return (
    <>
      <nav className={`nav ${scrolled ? "stuck" : ""}`}>
        <div className="nav-inner">
          <div className="logo" onClick={() => go("home")}>
            dev<span>yugal</span>
          </div>
          <div className="nav-links">
            {links.map((l) => (
              <span
                key={l.label}
                className={`nav-link ${page === l.page && !l.hash ? "active" : ""}`}
                onClick={() => { go(l.page); if (l.hash) setTimeout(() => document.querySelector(l.hash)?.scrollIntoView({ behavior: "smooth" }), 100); }}
              >
                {l.label}
              </span>
            ))}
          </div>
          <button className="nav-cta" onClick={() => go("contact")}>Let's Talk</button>
          <div className={`hamburger ${open ? "open" : ""}`} onClick={() => setOpen(!open)}>
            <span /><span /><span />
          </div>
        </div>
      </nav>

      {open && (
        <div className="mobile-menu">
          <button onClick={() => setOpen(false)} style={{ position: "absolute", top: 28, right: 28, background: "none", border: "none", color: "var(--text2)", fontSize: 24, cursor: "pointer" }}>✕</button>
          {["home", "case-studies", "contact"].map((p) => (
            <span key={p} className="mobile-nav-link" onClick={() => go(p)}>
              {p === "home" ? "Home" : p === "case-studies" ? "Work" : "Contact"}
            </span>
          ))}
        </div>
      )}
    </>
  );
}

/* ─────────────────────────────────────────────
   HOME PAGE
───────────────────────────────────────────── */
function HeroSection({ setPage }) {
  return (
    <section className="hero" style={{ justifyContent: "center" }}>
      <div className="hero-glow" style={{ width: 700, height: 700, background: "radial-gradient(ellipse, rgba(124,58,237,0.18), rgba(168,85,247,0.06) 50%, transparent 70%)", top: "50%", left: "50%", transform: "translate(-50%,-50%)" }} />

      {/* Inner two-column wrapper */}
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 60, width: "100%", maxWidth: 1100, padding: "0 40px",
        position: "relative", zIndex: 1,
      }}>

        {/* Left: text */}
        <div style={{ maxWidth: 600, flex: "1 1 auto" }}>
          <div className="hero-eyebrow reveal">
            <span className="hidden sm:inline">
              Full Stack Developer &middot; Systems Engineer
            </span>
            <span className="inline sm:hidden">
              Full Stack Developer<br/>Systems Engineer
            </span>
          </div>
     
          <h1 className="hero-title reveal d1">
            <span className="light">I build systems</span><br />
            that power<br />
            <span className="accent">real businesses.</span>
          </h1>
          <p className="hero-sub reveal d2">
            Scalable web applications, internal tools, and automation platforms
            that help organizations streamline workflows and operate smarter.
          </p>
          <div className="hero-actions reveal d3">
            <button className="btn-primary" onClick={() => { setPage("case-studies"); window.scrollTo(0, 0); }}>
              View Case Studies
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </button>
            <button className="btn-outline" onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>
              Contact Me
            </button>
          </div>
        </div>

        {/* Right: floating cards */}
        <div className="hero-visual reveal d2">
          <div className="hv-card hv-card1">
            <p className="hv-label">Monthly Revenue Processed</p>
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
              <div>
                <div className="hv-value">₹14.2L</div>
                <div className="hv-sub">↑ 23% vs last month</div>
              </div>
              <div className="hv-chip">
                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#4ade80", display: "inline-block" }} />
                Live
              </div>
            </div>
            <div className="hv-bars">
              {[30, 55, 40, 70, 50, 85, 60, 95, 72, 88, 65, 100].map((h, i) => (
                <div key={i} className={`hv-bar ${i >= 9 ? "active" : ""}`}
                  style={{ height: `${h}%`, animationDelay: `${i * 0.06}s` }} />
              ))}
            </div>
          </div>

          <div className="hv-card hv-card2">
            <p className="hv-label">System Status</p>
            <div className="hv-row">
              <span className="hv-row-label"><span className="hv-dot green" />Booking API</span>
              <span className="hv-row-val" style={{ color: "#4ade80" }}>99.9% uptime</span>
            </div>
            <div className="hv-row">
              <span className="hv-row-label"><span className="hv-dot" />Vendor Sync</span>
              <span className="hv-row-val">Real-time</span>
            </div>
            <div className="hv-row">
              <span className="hv-row-label"><span className="hv-dot orange" />Data Pipeline</span>
              <span className="hv-row-val" style={{ color: "#fb923c" }}>Processing</span>
            </div>
          </div>

          <div className="hv-card hv-card3">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <p className="hv-label">Manual Work Eliminated</p>
                <div className="hv-value" style={{ fontSize: 22 }}>100%</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <p className="hv-label">Vendors Managed</p>
                <div className="hv-value" style={{ fontSize: 22 }}>40+</div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div className="scroll-hint">
        <span>Scroll</span>
        <div className="scroll-arrow" />
      </div>
    </section>
  );
}

function ClientsSection() {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <section className="clients-section">
      <div className="wrap">
        <p className="clients-label reveal">
          Some of the <strong>businesses I've built for</strong>
        </p>
      </div>
      <div className="marquee-wrap">
        <div className="marquee-track">
          {items.map((name, i) => (
            <div key={i} className="client-item">
              <div className="client-dot" />
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function WorkSection({ setPage, setProject }) {
  return (
    <section className="work-section" id="work">
      <div className="wrap">
        <p className="section-label reveal">Selected Work</p>
        <h2 className="section-heading reveal d1">
          <span className="dim">Systems I've</span><br />
          engineered.
        </h2>

        <div className="work-list" style={{ marginTop: 72 }}>
          {PROJECTS.map((p, i) => (
            <div
              key={p.id}
              className={`work-item reveal d${(i % 3) + 1} ${i % 2 === 1 ? "flip" : ""}`}
              onClick={() => { setProject(p.id); setPage("detail"); window.scrollTo(0, 0); }}
            >
              <div className="work-img">
                <div className="work-img-inner" style={{ background: p.gradient }}>
                  <div style={{ textAlign: "center", padding: 32 }}>
                    <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 72, color: "rgba(255,255,255,0.08)", lineHeight: 1 }}>{p.num}</div>
                    <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", letterSpacing: "0.1em", textTransform: "uppercase", marginTop: 8 }}>{p.subtitle}</div>
                  </div>
                </div>
                <span className="work-num">{p.num}</span>
              </div>
              <div className="work-info">
                <p className="work-category">{p.category}</p>
                <h3 className="work-title">{p.title}</h3>
                <p className="work-desc">{p.desc}</p>
                <div className="work-tags">
                  {p.tags.map((t) => <span key={t} className="tag">{t}</span>)}
                </div>
                <span className="work-link">
                  View Case Study
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function OtherProjects() {
  return (
    <section style={{ padding: "80px 0", borderTop: "1px solid var(--border)" }}>
      <div className="wrap">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 48, flexWrap: "wrap", gap: 16 }}>
          <div>
            <p className="section-label reveal">More Projects</p>
            <h2 className="section-heading reveal d1" style={{ fontSize: "clamp(28px, 4vw, 44px)" }}>
              <span className="dim">60+ projects</span><br />
              delivered.
            </h2>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "1px", background: "var(--border)", border: "1px solid var(--border)", borderRadius: 16, overflow: "hidden" }}>
          {OTHER_PROJECTS.map((p, i) => (
            <div
              key={p.name}
              className="reveal"
              style={{
                padding: "28px 30px", background: "var(--bg)",
                transition: "background 0.3s", cursor: "pointer",
              }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--bg2)"}
              onMouseLeave={e => e.currentTarget.style.background = "var(--bg)"}
              onClick={() => p.url !== "#" && window.open(p.url, "_blank")}
            >
              <p style={{ fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--accent)", marginBottom: 10 }}>{p.category}</p>
              <h3 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 20, color: "var(--text1)", marginBottom: 8, lineHeight: 1.2 }}>{p.name}</h3>
              <p style={{ fontSize: 13, color: "var(--text3)", fontWeight: 300 }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AboutSection() {
  return (
    <section className="about-section" id="about">
      <div className="wrap">
        <div className="about-grid">
          <div>
            <p className="about-label reveal">A bit about me</p>
            <h2 className="about-text reveal d1">
              <span className="dim">Hey, I'm</span> Yugal Raj —<br />
              a developer from<br />
              <em>Uttarakhand, India.</em>
            </h2>
            <p className="about-body reveal d2">
              I don't just build websites — I engineer systems. From multi-role business platforms
              to automation pipelines that replace entire manual workflows, I focus on software
              that has real operational impact.
            </p>
            <p className="about-body reveal d3" style={{ marginTop: -12 }}>
              I specialize in full-stack development with a focus on business automation,
              internal tools, and data-rich dashboards. I also work with GSAP, Framer Motion,
              and Three.js for expressive, high-quality interfaces.
            </p>
            <div className="about-stats reveal d4">
              {[
                { num: "4+", label: "Years building" },
                { num: "40+", label: "Businesses served" },
                { num: "60+", label: "Projects shipped" },
              ].map((s) => (
                <div key={s.label}>
                  <div className="stat-num">{s.num}</div>
                  <div className="stat-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-visual reveal d2">
            {Object.entries(TECH).map(([group, techs]) => (
              <div key={group} className="tech-section-inner">
                <p className="tech-section-title">{group}</p>
                <div className="tech-grid">
                  {techs.map((t) => <span key={t} className="tech-pill">{t}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function ServicesSection() {
  return (
    <section className="services-section">
      <div className="wrap">
        <p className="section-label reveal">What I Do</p>
        <h2 className="section-heading reveal d1">
          <span className="dim">Services I</span><br />
          offer.
        </h2>
        <div className="services-grid">
          {SERVICES.map((s) => (
            <div key={s.num} className="service-card glow-card reveal"
              onMouseMove={e => {
                const r = e.currentTarget.getBoundingClientRect();
                e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
              }}
            >
              <p className="service-num">{s.num}</p>
              <div className="service-icon">{s.icon}</div>
              <h3 className="service-title">{s.title}</h3>
              <p className="service-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactTeaser({ setPage }) {
  return (
    <section style={{ padding: "80px 0", borderTop: "1px solid var(--border)" }}>
      <div className="wrap-s" style={{ textAlign: "center" }}>
        <p className="section-label reveal" style={{ justifyContent: "center", display: "block" }}>Let's Build Together</p>
        <h2 className="section-heading reveal d1" style={{ fontSize: "clamp(36px, 6vw, 72px)", textAlign: "center", marginBottom: 24 }}>
          <span className="dim">Have a project</span><br />
          in mind?
        </h2>
        <p className="reveal d2" style={{ fontSize: 16, fontWeight: 300, color: "var(--text2)", lineHeight: 1.75, marginBottom: 40, maxWidth: 420, margin: "0 auto 40px" }}>
          Whether it's a system rebuild, a new automation platform, or a product from scratch — let's talk.
        </p>
        <div className="reveal d3" style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
          <button className="btn-primary" onClick={() => { setPage("contact"); window.scrollTo(0, 0); }}>
            Start a Project
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          </button>
          <a href="https://wa.me/+919837114001" target="_blank" rel="noreferrer" className="btn-outline" style={{ textDecoration: "none" }}>
            WhatsApp Me
          </a>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   FOOTER
───────────────────────────────────────────── */



function Footer({ setPage }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-copy">© 2025 Yugal Raj Vimal · devyugal.in</span>
        <div className="footer-links">
          <Link to="/" className="footer-link">Home</Link>
          <Link to="/case-studies/milk-association-system" className="footer-link">Case Studies</Link>
          <Link to="/contact" className="footer-link" onClick={() => setPage && setPage("contact")}>Contact</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
          <Link to="/data-deletion-instruction" className="footer-link">Data Deletion Instruction</Link>
        </div>
        <span className="footer-copy">yugal@devyugal.in</span>
      </div>
    </footer>
  );
}

/* ─────────────────────────────────────────────
   HOME PAGE
───────────────────────────────────────────── */
function HomePage({ setPage, setProject }) {
  useScrollReveal();
  return (
    <div className="page">
      <HeroSection setPage={setPage} />
      <div className="sep" />
      <ClientsSection />
      <div className="sep" />
      <WorkSection setPage={setPage} setProject={setProject} />
      <OtherProjects />
      <div className="sep" />
      <ServicesSection />
      <div className="sep" />
      <AboutSection />
      <ContactTeaser setPage={setPage} />
      <Footer setPage={setPage} />
    </div>
  );
}

/* ─────────────────────────────────────────────
   CASE STUDIES PAGE
───────────────────────────────────────────── */
function CaseStudiesPage({ setPage, setProject }) {
  useScrollReveal();
  return (
    <div className="page">
      <section className="cs-page-hero">
        <div className="wrap">
          <p className="section-label reveal">Case Studies</p>
          <h1 className="section-heading reveal d1" style={{ fontSize: "clamp(44px, 7vw, 80px)", marginBottom: 20 }}>
            <span className="dim">Work that</span><br />
            moves businesses.
          </h1>
          <p className="reveal d2" style={{ fontSize: 17, fontWeight: 300, color: "var(--text2)", maxWidth: 520, lineHeight: 1.75 }}>
            Deep dives into the platforms, systems, and automation tools I've engineered for real businesses.
          </p>
        </div>
      </section>

      <div className="sep" />

      <section style={{ padding: "80px 0" }}>
        <div className="wrap">
          <div className="cs-grid">
            {PROJECTS.map((p, i) => (
              <div
                key={p.id}
                className={`cs-card reveal d${i + 1}`}
                onClick={() => { setProject(p.id); setPage("detail"); window.scrollTo(0, 0); }}
              >
                <div className="cs-card-banner">
                  <div className="cs-card-banner-inner" style={{ background: p.gradient, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 80, color: "rgba(255,255,255,0.07)", lineHeight: 1 }}>{p.num}</div>
                  </div>
                </div>
                <div className="cs-card-body">
                  <p className="cs-card-cat">{p.category}</p>
                  <h3 className="cs-card-title">{p.title}</h3>
                  <p className="cs-card-desc">{p.desc}</p>
                  <div className="work-tags">
                    {p.tags.map((t) => <span key={t} className="tag">{t}</span>)}
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <span className="work-link">
                      View Case Study
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactTeaser setPage={setPage} />
      <Footer setPage={setPage} />
    </div>
  );
}

/* ─────────────────────────────────────────────
   DETAIL PAGE
───────────────────────────────────────────── */
function DetailPage({ projectId, setPage }) {
  const p = PROJECTS.find((x) => x.id === projectId) || PROJECTS[0];
  useScrollReveal();

  return (
    <div className="page">
      {/* Hero */}
      <section className="detail-hero" style={{ background: `linear-gradient(180deg, rgba(8,8,16,0) 0%, rgba(8,8,16,0.95) 100%), ${p.gradient}` }}>
        <div className="wrap">
          <button className="detail-back" onClick={() => { setPage("case-studies"); window.scrollTo(0, 0); }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
            Back to Work
          </button>
          <p className="detail-cat">{p.category}</p>
          <h1 className="detail-title reveal">{p.title}</h1>
          <p className="detail-subtitle reveal d1">{p.desc}</p>
          <div className="detail-meta reveal d2">
            <div className="detail-meta-item"><label>Type</label><span>{p.category}</span></div>
            <div className="detail-meta-item"><label>Stack</label><span>{p.tags.join(", ")}</span></div>
            {p.url !== "#" && (
              <div className="detail-meta-item">
                <label>Live Site</label>
                <a href={p.url} target="_blank" rel="noreferrer" style={{ color: "var(--accent)", fontSize: 14, textDecoration: "none", borderBottom: "1px solid rgba(155,93,229,0.3)", paddingBottom: 2 }}>Visit →</a>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Body */}
      <div className="detail-body">
        <div className="wrap-s">
          {/* Problem */}
          <div className="detail-section reveal">
            <p className="detail-section-label">The Problem</p>
            <h2 className="detail-section-title">What needed solving</h2>
            <p className="detail-text">{p.problem}</p>
          </div>

          {/* Solution */}
          <div className="detail-section reveal d1">
            <p className="detail-section-label">The Solution</p>
            <h2 className="detail-section-title">How I approached it</h2>
            <p className="detail-text">{p.solution}</p>
          </div>

          {/* Features */}
          <div className="detail-section reveal">
            <p className="detail-section-label">Key Features</p>
            <h2 className="detail-section-title">What was built</h2>
            <div className="detail-features">
              {p.features.map((f) => (
                <div key={f.title} className="detail-feature">
                  <h3 className="detail-feature-title">{f.title}</h3>
                  <p className="detail-feature-desc">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Tech Stack */}
          <div className="detail-section reveal d1">
            <p className="detail-section-label">Tech Stack</p>
            <h2 className="detail-section-title">Built with</h2>
            <div className="work-tags" style={{ marginTop: 20 }}>
              {p.tags.map((t) => <span key={t} className="tag" style={{ borderColor: `${p.accentColor}33`, color: p.accentColor }}>{t}</span>)}
            </div>
          </div>

          {/* Challenges */}
          <div className="detail-section reveal">
            <p className="detail-section-label">Engineering Challenges</p>
            <h2 className="detail-section-title">The hard parts</h2>
            <p className="detail-text">{p.challenges}</p>
          </div>

          {/* Results */}
          <div className="detail-section reveal d1">
            <p className="detail-section-label">Results</p>
            <h2 className="detail-section-title">What was achieved</h2>
            <div className="detail-results">
              {p.results.map((r) => (
                <div key={r.label} className="result-pill">
                  <div className="result-num" style={{ color: p.accentColor }}>{r.num}</div>
                  <div className="result-text">{r.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Other case studies */}
      <div className="sep" />
      <section style={{ padding: "80px 0" }}>
        <div className="wrap">
          <p className="section-label reveal">Other Case Studies</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 20, marginTop: 36 }}>
            {PROJECTS.filter((x) => x.id !== p.id).map((op) => (
              <div
                key={op.id}
                className="cs-card reveal"
                onClick={() => { setPage("detail"); window.location.search = `?p=${op.id}`; window.scrollTo(0, 0); }}
              >
                <div className="cs-card-banner">
                  <div className="cs-card-banner-inner" style={{ background: op.gradient, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 64, color: "rgba(255,255,255,0.07)" }}>{op.num}</div>
                  </div>
                </div>
                <div className="cs-card-body">
                  <p className="cs-card-cat">{op.category}</p>
                  <h3 className="cs-card-title">{op.title}</h3>
                  <span className="work-link" style={{ marginTop: 8, display: "inline-flex" }}>
                    View Case Study
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer setPage={setPage} />
    </div>
  );
}

/* ─────────────────────────────────────────────
   TOAST
───────────────────────────────────────────── */
function Toast({ message, type, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 3500);
    return () => clearTimeout(t);
  }, [onDone]);
  const icons = { success: "✓", error: "✕", info: "ℹ" };
  return <div className={`toast ${type}`}>{icons[type]} {message}</div>;
}

/* ─────────────────────────────────────────────
   CONTACT PAGE
───────────────────────────────────────────── */
function ContactPage({ setPage }) {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [toast, setToast] = useState(null);
  useScrollReveal();

  const showToast = (message, type = "info") => setToast({ message, type });

  const handleMessage = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const name = formData.get("name");
    const email = formData.get("email");
    const message = formData.get("message");

    event.target.reset();
    setSending(true);
    showToast("Sending your message…", "info");

    try {
      const response = await axios.post(
        "https://portfolio-mailer-19fc.onrender.com/send-mail",
        { name, email, message }
      );

      setSending(false);
      if (response.status === 200) {
        setSent(true);
        setForm({ name: "", email: "", message: "" });
        showToast("Message sent! I'll reply within 24 hours.", "success");
        setTimeout(() => setSent(false), 5000);
      }
    } catch (error) {
      setSending(false);
      console.error("Error sending email:", error);
      showToast("Failed to send message. Please email directly.", "error");
    }
  };

  return (
    <div className="page">
      {toast && <Toast message={toast.message} type={toast.type} onDone={() => setToast(null)} />}
      <section className="contact-section">
        <div className="contact-glow" />

        <div className="wrap-s" style={{ position: "relative", zIndex: 1 }}>
          <div className="contact-title reveal">
            <span className="dim">Get</span> in <span className="accent">Touch.</span>
          </div>
          <p className="contact-sub reveal d1">
            Have a project in mind? Let's make it happen.
          </p>

          {/* Trust signals */}
          <div className="contact-trust reveal d1">
            <span className="trust-pill"><span className="trust-dot" />Usually replies within 24 hours</span>
            <span className="trust-pill">📍 Uttarakhand, India</span>
            <span className="trust-pill">✓ Open to new projects</span>
          </div>
          <div className="contact-icons reveal d2">
            {[
              { href: "mailto:yugal@devyugal.in", icon: "✉", label: "Email" },
              { href: "https://wa.me/+919837114001", icon: "💬", label: "WhatsApp" },
              { href: "https://github.com", icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>, label: "GitHub" },
              { href: "https://linkedin.com", icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>, label: "LinkedIn" },
            ].map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="contact-icon-btn" title={s.label}>
                {typeof s.icon === "string" ? s.icon : s.icon}
              </a>
            ))}
          </div>

          <div className="contact-email reveal d2">
            <a href="mailto:yugal@devyugal.in">yugal@devyugal.in</a>
          </div>

          <form
            id="messageForm"
            className="contact-form reveal d3"
            onSubmit={handleMessage}
            autoComplete="off"
          >
            <h3
              style={{
                fontFamily: "'DM Serif Display', serif",
                fontSize: 28,
                color: "var(--text1)",
                marginBottom: 32,
                letterSpacing: "-0.01em",
                textAlign: "left",
              }}
            >
              Shoot me a message.
            </h3>

            {sent && (
              <div
                style={{
                  padding: "14px 18px",
                  borderRadius: 10,
                  background: "rgba(34,197,94,0.08)",
                  border: "1px solid rgba(34,197,94,0.2)",
                  color: "#4ade80",
                  fontSize: 14,
                  marginBottom: 24,
                }}
              >
                ✓ Message sent — I'll reply within 24 hours.
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Your Name</label>
              <input
                className="form-input"
                name="name"
                placeholder="Yugal Raj"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                className="form-input"
                type="email"
                name="email"
                placeholder="you@email.com"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label className="form-label">Your Message</label>
              <textarea
                className="form-input"
                name="message"
                placeholder="Tell me about your project..."
                value={form.message}
                onChange={e => setForm({ ...form, message: e.target.value })}
                required
              />
            </div>
            <button
              className="btn-primary form-submit"
              type="submit"
              disabled={sending}
              style={sending ? { opacity: 0.6, pointerEvents: "none" } : undefined}
            >
              {sending ? (
                <>
                  Sending...
                </>
              ) : (
                <>
                  Send Message
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </>
              )}
            </button>
          </form>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-inner">
          <span className="footer-copy">© 2025 Yugal Raj Vimal · devyugal.in</span>
          <span className="footer-copy">Made with care ♥</span>
        </div>
      </footer>
    </div>
  );
}



export default function Home() {
  const [page, setPage] = useState("home");
  const [projectId, setProjectId] = useState("nupal-cdc");

  const render = () => {
    switch (page) {
      case "home":         return <HomePage setPage={setPage} setProject={setProjectId} />;
      case "case-studies": return <CaseStudiesPage setPage={setPage} setProject={setProjectId} />;
      case "detail":       return <DetailPage projectId={projectId} setPage={setPage} />;
      case "contact":      return <ContactPage setPage={setPage} />;
      default:             return <HomePage setPage={setPage} setProject={setProjectId} />;
    }
  };

  return (
    <>
      <Styles />
      <Nav page={page} setPage={setPage} />
      {render()}
    </>
  );
}